import { Injectable } from '@angular/core';
import { APIService } from './api.service';
import { DataService } from './data.service';
import { AnEvent, Draw, Entry, Match, Player, Tornament } from './Main.Model';

@Injectable({
  providedIn: 'root'
})
export class FunctionService {

  Today: Date;

  constructor(public DataService: DataService, private APIService: APIService) { 
    this.Today = new Date();
  }

  getDetailsFromEntry() {
    this.checkToSeeIfLoggedInUserIsInSelectedTorn();
        //Create List of AvailablePlayers from Entries
        if (this.DataService.SelectedTorn) {
            this.DataService.SelectedTorn.SinglesPlayers = [];
            this.DataService.SelectedTorn.DoublesPlayers = [];
            if (this.DataService.SelectedTorn.entries) {
                for (var e = 0; e < this.DataService.SelectedTorn.entries.length; e++) {
                    var Entry = this.DataService.SelectedTorn.entries[e];
                    // if (!Entry.events) {
                    //   this.populateEventsEntered(Entry);
                    // }
                    // if (Entry.playerId == 0) {
                    //   this.AlertService.showSimpleAlert(Entry.name + " has no ID!");
                    //     //this.ShowMessage("note", Entry.name + " has no ID!");
                    // }
                    const PlayerRecord = this.DataService.Players?.find((p) => p.id == Entry.playerId)//getPlayerObject(Entry.playerId, this.DataService.Players);
                    if (Entry && PlayerRecord) {
                        if (Entry.team && Entry.team > 0) {
                            PlayerRecord.Team = Entry.team;
                        }
                        //var PartnersPlayerRecord = this.DataService.Players.find((p) => p.id == Entry.PartnerId)//getPlayerObject(Entry.PartnerId, this.DataService.Players);
                        
                        //Entry.DOB = PlayerRecord.DOB;
                        Entry.YearsOld = 99;//often we use 100 as max age
                        if (PlayerRecord.DOB) {
                            Entry.YearsOld = this.getDateDiff(PlayerRecord.DOB, this.Today, "years");
                        } else {
                            Entry.YearsOld = 0;
                        }
                        Entry.gender = PlayerRecord.gender;
                        Entry.SendAnnouncement = false;
                        //PlayerRecord.Partner = Entry.Partner; //grab details from Entry
                        //PlayerRecord.PartnerId = Entry.PartnerId;
                        //PlayerRecord.Singles = Entry.Singles; //make these available for later
                        //PlayerRecord.Doubles = Entry.DoublesMixed;

                        // if (Entry.PartnerId > 0) {
                        //     PlayerRecord.DoublesTotalPoints = PlayerRecord.DoublesPoints + PartnersPlayerRecord.DoublesPoints;//this.getTotalDoublesPoints(PlayerRecord, PartnersPlayerRecord); //well this is clearly wrong!!!
                        // }
                        if (Entry.eventsList != null) {//get doubs points for new method of storing partners
                            if (Entry.eventsList.length > 0) {

                                Entry.eventsList.forEach( anEvent => {
                                    if (anEvent && anEvent.PartnerId &&anEvent.PartnerId > 0) {//if doubs
                                        const PartnersRecord = this.DataService.Players?.find((p) => p.id == anEvent.PartnerId)//getPlayerObject(anEvent.PartnerId, this.Data.Players);
                                        //PlayerRecord.Partner = PartnersRecord.Name;
                                        //PlayerRecord.PartnerGender = PartnersRecord.Gender;
                                        anEvent.DoublesTotalPoints = (PlayerRecord?.doublesPoints || 0) + (PartnersRecord?.doublesPoints || 0);//this.getTotalDoublesPoints(PlayerRecord, PartnersRecord);
                                        //PlayerRecord.DoublesTotalPoints = anEvent.DoublesTotalPoints;
                                    }
                                })
                            }
                        }
                        if (Entry.singles) {
                            this.DataService.SelectedTorn.SinglesPlayers.push(PlayerRecord);
                        }
                        if (Entry.doublesMixed) {
                            this.DataService.SelectedTorn.DoublesPlayers.push(PlayerRecord);
                        }
                        //need to create lists to show for torns that have no events:
                    }
                }
            }

            this.DataService.SelectedTorn.SinglesPlayers.sort(function (a, b) {
                return (b.singlesPoints || 0) - (a.singlesPoints || 0);
            });
            this.DataService.SelectedTorn.DoublesPlayers.sort(function (a, b) {
                return (b.doublesPoints || 0) - (a.doublesPoints || 0);
            });
        }
        this.RecalcEventTotals();
  }

  calcGrade(points: number, gender: string  ) {
    if (gender == 'M') {
      if (points > 3000) {
          return 'A';
      } else if (points > 2600) {
          return 'B';
      } else if (points > 2200) {
          return 'C';
      } else if (points > 1800) {
          return 'D';
      } else if (points > 1400) {
          return 'E';
      } else if (points > 0) {
          return 'F';
      } else {
          return 'F';
      }
  } else {
      if (points > 2400) {
          return 'A';
      } else if (points > 2000) {
          return 'B';
      } else if (points > 1600) {
          return 'C';
      } else if (points > 1200) {
          return 'D';
      } else if (points > 800) {
          return 'E';
      } else if (points > 0) {
          return 'F';
      } else {
          return 'F';
      }
    }
  }

  addMinutes(OldDate: Date, numOfMins: number) {
    return new Date(OldDate.getTime() + numOfMins * 60000);
  }

  addHours(numOfHours: number, date = new Date()) {
    return new Date(date.setHours(date.getHours() + numOfHours));   
  }

  addDays(numOfDays: number, date = new Date()) {
    return new Date(date.setDate(date.getDate() + numOfDays)); 
  }

  addYears(numOfYears: number, date: Date) 
  {
    return new Date(date.setFullYear(date.getFullYear() + numOfYears));      
  }

  getDateDiff(Date1: Date, Date2: Date, unit: string) {
   if (unit == 'days') {
    return Math.floor((Date1.getTime() - Date2.getTime()) / 1000 / 60 / 60 / 24);
   }  else if (unit == 'years') {
    var ageDifMs = Date1.getTime() - Date2.getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
   } else if (unit == 'mins') {
    var diff = (Date2.getTime() - Date1.getTime()) / 1000;
    diff /= 60;
    return Math.abs(Math.round(diff));
   }
  }

  CalcAPlayersRankingData(ThePlayer: Player, Played: string) {
    //will not work if no matches:
    var YearsAgo1 = this.addYears(-1,new Date());
    var YearsAgo2 = this.addYears(-2, new Date());
    ThePlayer.hasPlayedSinglesInLast2Years = false;
    ThePlayer.hasPlayedDoublesInLast2Years = false;
    ThePlayer.hasPlayedInLastYear = false;
    ThePlayer.hasPlayedSinglesInLastYear = false;
    ThePlayer.hasPlayedDoublesInLastYear = false;
    ThePlayer.SinglesMatchesPlayed = 0;
    ThePlayer.DoublesMatchesPlayed = 0;
    ThePlayer.TotalPointsWonTT = 0
    ThePlayer.TotalPointsWonBad = 0
    ThePlayer.TotalPointsWonSq = 0
    ThePlayer.TotalPointsWonT = 0
    ThePlayer.TotalPointsLostTT = 0
    ThePlayer.TotalPointsLostBad = 0
    ThePlayer.TotalPointsLostSq = 0
    ThePlayer.TotalPointsLostT = 0
    ThePlayer.hasPlayedSingles = false;
    ThePlayer.hasPlayedDoubles = false;
    for (var m = 0; m < this.DataService.Matches!.length; m++) {
        //this.DataService.Matches[m].dateOfMatch = new Date(this.DataService.Matches[m].dateOfMatch);
      var TheMatch = this.DataService.Matches![m];
      if (TheMatch.player1 == ThePlayer.id || TheMatch.player2 == ThePlayer.id || TheMatch.player3 == ThePlayer.id || TheMatch.player4 == ThePlayer.id) {
        if (TheMatch.notPlayed == false && (TheMatch.ttScore1! + TheMatch.badScore1! + TheMatch.squashScore1! + TheMatch.tScore1! + TheMatch.ttScore2! + TheMatch.badScore2! + TheMatch.squashScore2! + TheMatch.tScore2!) > 0) {
            if (TheMatch.player3 == 0) {
                ThePlayer.hasPlayedSingles = true;
                ThePlayer.SinglesMatchesPlayed = ThePlayer.SinglesMatchesPlayed + 1;
            } else {
                ThePlayer.hasPlayedDoubles = true;
                ThePlayer.DoublesMatchesPlayed = ThePlayer.DoublesMatchesPlayed + 1;
            }
            if (TheMatch.dateOfMatch! > YearsAgo2 && TheMatch.player4 == 0) {
                ThePlayer.hasPlayedSinglesInLast2Years = true;
            } else if (TheMatch.dateOfMatch! > YearsAgo2 && TheMatch.player4! > 0) {
                ThePlayer.hasPlayedDoublesInLast2Years = true;
            }
            if (TheMatch.dateOfMatch! > YearsAgo1) {
                ThePlayer.hasPlayedInLastYear = true;
                if (TheMatch.player4! > 0) {
                    ThePlayer.hasPlayedDoublesInLastYear = true;
                } else {
                    ThePlayer.hasPlayedSinglesInLastYear = true;
                }
            }
        }
    }
    //experimental new rating system
    if (TheMatch.player3 == 0 && ((Played == 'Last1Year' && TheMatch.dateOfMatch! > YearsAgo1) || (Played == 'Last2Years' && TheMatch.dateOfMatch! > YearsAgo2) || Played == 'Zero')) {//only worry about singles matches
        if (ThePlayer.id == TheMatch.player1) {
            ThePlayer.TotalPointsWonTT = ThePlayer.TotalPointsWonTT + TheMatch.ttScore1!;
            ThePlayer.TotalPointsWonBad = ThePlayer.TotalPointsWonBad + TheMatch.badScore1!;
            ThePlayer.TotalPointsWonSq = ThePlayer.TotalPointsWonSq + TheMatch.squashScore1!;
            ThePlayer.TotalPointsWonT = ThePlayer.TotalPointsWonT + TheMatch.tScore1!;
            ThePlayer.TotalPointsLostTT = ThePlayer.TotalPointsLostTT + TheMatch.ttScore2!;
            ThePlayer.TotalPointsLostBad = ThePlayer.TotalPointsLostBad + TheMatch.badScore2!;
            ThePlayer.TotalPointsLostSq = ThePlayer.TotalPointsLostSq + TheMatch.squashScore2!;
            ThePlayer.TotalPointsLostT = ThePlayer.TotalPointsLostT + TheMatch.tScore2!;
        } else if (ThePlayer.id == TheMatch.player2) {
            ThePlayer.TotalPointsWonTT = ThePlayer.TotalPointsWonTT + TheMatch.ttScore2!;
            ThePlayer.TotalPointsWonBad = ThePlayer.TotalPointsWonBad + TheMatch.badScore2!;
            ThePlayer.TotalPointsWonSq = ThePlayer.TotalPointsWonSq + TheMatch.squashScore2!;
            ThePlayer.TotalPointsWonT = ThePlayer.TotalPointsWonT + TheMatch.tScore2!;
            ThePlayer.TotalPointsLostTT = ThePlayer.TotalPointsLostTT + TheMatch.ttScore1!;
            ThePlayer.TotalPointsLostBad = ThePlayer.TotalPointsLostBad + TheMatch.badScore1!;
            ThePlayer.TotalPointsLostSq = ThePlayer.TotalPointsLostSq + TheMatch.squashScore1!;
            ThePlayer.TotalPointsLostT = ThePlayer.TotalPointsLostT + TheMatch.tScore1!;
        }
      }
    }
    ThePlayer.SinglesGrade = this.calcGrade(ThePlayer.singlesPoints!, ThePlayer.gender!);
    ThePlayer.DoublesGrade = this.calcGrade(ThePlayer.doublesPoints!, ThePlayer.gender!);
    //calc new experimental system
    ThePlayer.TTRating = ThePlayer.TotalPointsWonTT / (ThePlayer.TotalPointsWonTT + ThePlayer.TotalPointsLostTT) * 100;
    ThePlayer.BadRating = ThePlayer.TotalPointsWonBad / (ThePlayer.TotalPointsWonBad + ThePlayer.TotalPointsLostBad) * 100;
    ThePlayer.SqRating = ThePlayer.TotalPointsWonSq / (ThePlayer.TotalPointsWonSq + ThePlayer.TotalPointsLostSq) * 100;
    ThePlayer.TRating = ThePlayer.TotalPointsWonT / (ThePlayer.TotalPointsWonT + ThePlayer.TotalPointsLostT) * 100;
    ThePlayer.TTRating = Math.round(ThePlayer.TTRating);
    ThePlayer.BadRating = Math.round(ThePlayer.BadRating);
    ThePlayer.SqRating = Math.round(ThePlayer.SqRating);
    ThePlayer.TRating = Math.round(ThePlayer.TRating);
    return ThePlayer
  }

  convertTornDates(torn: Tornament) {
    torn.dateOfEvent = new Date(torn.dateOfEvent!);
      torn.closingDate = new Date(torn.closingDate!);
      torn.endDateOfEvent = new Date(torn.endDateOfEvent!);
      return torn;
  }

  checkToSeeIfLoggedInUserIsInSelectedTorn() {
    this.DataService.LoggedInUserAlreadyEnteredInTorn = false;
        if (this.DataService.SelectedTorn && this.DataService.LoggedInUser) {
            if (this.DataService.SelectedTorn.entries) {
                for (var e = 0; e < this.DataService.SelectedTorn.entries.length; e++) {
                    if (this.DataService.LoggedInUser.id == this.DataService.SelectedTorn.entries[e].playerId) {
                        this.DataService.LoggedInUserAlreadyEnteredInTorn = true;
                        break;
                    }
                }
            }
        }
  }

  async WhichTornsIsLoggedInUserIn() {//this is to show a star beside each torn that the user has entered
    if (this.DataService.LoggedInUser) {
        if (this.DataService.LoggedInUser.accessLevel! > 0) {
            var ListOfTornsEntered = [] as any;
            ListOfTornsEntered = await this.APIService.GetTornsEntered(this.DataService.LoggedInUser.id);
            if (ListOfTornsEntered.length > 0) {
                this.DataService.Torns?.forEach(torn => {
                    if (ListOfTornsEntered.indexOf(torn.id) > -1) {
                        torn.UserEntered = true;
                    } else {
                        torn.UserEntered = false;
                    }
                });
            }
        }
    }
  }

  ShouldWeAllowUpdate() {
    if (this.DataService.SelectedTorn) {
      var EndOfTornDateIn2Days = this.addDays(2, this.DataService.SelectedTorn.endDateOfEvent);
      this.DataService.AllowTornUpdate = false;
      if (this.DataService.SelectedTorn.endDateOfEvent) {
          if (EndOfTornDateIn2Days > this.Today || this.DataService.LoggedInUser?.accessLevel! > 2) {// || this.LoginState.AccessLevel > 2) {
              if (this.DataService.LoggedInUser?.accessLevel! > 1) {
                  this.DataService.AllowTornUpdate = true;
              }
          }
      }
    }
  }

  async RecalcEventTotals() {
    this.DataService.SelectedTorn!.isTeams = false;
    this.DataService.SelectedTorn?.events?.forEach(anEvent => {
        anEvent.Total = 0;
        if (anEvent.teams == true) {
            this.DataService.SelectedTorn!.isTeams = true;
        }
    })
        //need to also update totals for newEntry
        // array.forEach(element => {
          
        // });
        // angular.forEach(this.newEntry.EventsEntered, function (anEvent, index) {
        //     anEvent.Total = 0;
        //     angular.forEach(this.DataService.SelectedTorn.Entries, function (entry, index) {
        //         if (anEvent.Entered == true) {
        //             anEvent.Total = anEvent.Total + 1;
        //         }
        //     })
        // })
        
        //now total up how many players are in each event
        // this.DataService.SelectedTorn.entries.forEach(entry => {
        //   entry.events.forEach((anEvent, index) => {
        //         if (anEvent.Entered == true) {
        //             this.DataService.SelectedTorn.events[index].Total = this.DataService.SelectedTorn.events[index].Total + 1;
        //         }
        //     })
        // })

        //now show a tick or a cross..
        this.DataService.SelectedTorn!.events?.forEach(anEvent => {
            if (anEvent.maxAge! < 20) {//they can play more
                if (anEvent.Total! % 5 == 0 || anEvent.Total! % 8 == 0 || anEvent.Total! % 13 == 0 || anEvent.Total! % 18 == 0) {
                    anEvent.Good = true;
                } else {
                    anEvent.Good = false;
                }
            } else if (anEvent.type == 'Doubles') {
                if (anEvent.Total! % 10 == 0 || anEvent.Total! % 16 == 0 || anEvent.Total! % 26 == 0 || anEvent.Total! % 36 == 0) {
                    anEvent.Good = true;
                } else {
                    anEvent.Good = false;
                }
            } else {
                if (anEvent.Total! > 3 && anEvent.Total! % 2 == 0) {
                    anEvent.Good = true;
                } else {
                    anEvent.Good = false;
                }
            }
        })
   }

//   populateEventsEntered(entry) {
//     //entry.EventsEntered = this.DataService.SelectedTorn.events.slice();//angular.copy(this.DataService.SelectedTorn.events);
//     entry.EventsEntered = JSON.parse(JSON.stringify(this.DataService.SelectedTorn.events))
//     var EventEntries = entry.events.split(",");
//     EventEntries.forEach(indEventEntry => {
//       var indexOfStartBracket = indEventEntry.indexOf("(") + 1;
//       var posOfEndBracket;
//       var PartnerId = 0;
//       var EventId = 0;
//       var PartnerName;
//       if (indexOfStartBracket > 0) {
//         posOfEndBracket = indEventEntry.indexOf(")");
//         //var test = indEventEntry.substring(indexOfStartBracket, posOfEndBracket)
//         PartnerId = +indEventEntry.substring(indexOfStartBracket, posOfEndBracket)
//         var PartnerObject = this.DataService.Players.find((p) => p.id == PartnerId);
//         if (PartnerObject) {
//           PartnerName = PartnerObject.name;
//         }
//         //var test2 = indEventEntry.substring(0,indexOfStartBracket-1);
//         EventId = +indEventEntry.substring(0,indexOfStartBracket-1);
//       } else {
//         EventId = +indEventEntry;
//       }
//       entry.EventsEntered.forEach(_event => {
//         if (_event.id == EventId) {
//           _event.PartnerId = PartnerId;
//           _event.Entered = true;
//           _event.Partner.name = PartnerName;
//         }
//       });
//     });
//   }

  PushDistinct(ObjectToAdd: any, Collection: any[]) {
    for (var c = 0; c < Collection.length; c++) {
        if (Collection[c] == ObjectToAdd) {
            return
        }
    }
    Collection.push(ObjectToAdd);
    }

    CreatePlayersListForEachEvent() {
        this.DataService.SelectedTorn!.events?.forEach(_event => {
            _event.Players = [];
            this.DataService.SelectedTorn!.entries?.forEach(entry => {
                entry.eventsList!.forEach(EventEntered=> {
                    if (_event.id == EventEntered.id) {
                        //make sure not already in there
                        var boolAlreadyExists = false;
                        // if (_event.type == 'Doubles') {
                        //     _event.Players.forEach(TestPlayer => {
                        //         if (TestPlayer.Partner?.id == entry.playerId) {
                        //             boolAlreadyExists = true;
                        //         }
                        //     })
                        // }
                        var ThePlayer = this.DataService.Players?.find((p) => p.id == entry.playerId);
                        if (EventEntered.PartnerId && EventEntered.PartnerId > 0) {
                            //ThePlayer.Partner = EventEntered.Partner;
                            //ThePlayer.Partner.id = EventEntered.PartnerId;
                            //var PartnerObject = this.DataService.Players.find((p) => p.id == EventEntered.PartnerId);
                            //ThePlayer.Partner.gender = PartnerObject.gender;
                            //ThePlayer.DoublesTotalPoints = ThePlayer.doublesPoints + EventEntered.Partner.doublesPoints;
                            EventEntered.DoublesTotalPoints = ThePlayer?.doublesPoints! + EventEntered.Partner?.doublesPoints!;
                        }
                        if (boolAlreadyExists == false) {
                            _event?.Players!.push(ThePlayer!);
                        }
                    }
                })
            })
            if (_event.type == 'Singles') {
                _event.Players.sort(function (a, b) { return b.singlesPoints! - a.singlesPoints! })
            } else {
                _event.Players.sort(function (a, b) { return b.DoublesTotalPoints! - a.DoublesTotalPoints! })
            }
        })
    }

    getNewUser () {
    var newUser;
    newUser = new Player();
    newUser.country = "NZ";
    newUser.tableTennis = 10;
    newUser.badminton = 10;
    newUser.squash = 10;
    newUser.tennis = 10;
    newUser.singlesPoints = 1600;
    newUser.doublesPoints = 1600;
    newUser.badRating = 0;
    newUser.tRating = 0;
    newUser.sqRating = 0;
    newUser.ttRating = 0;
    newUser.DOB = undefined;
    newUser.email = "";
    newUser.province = "";
    newUser.phone = "";
    newUser.password = "";
    return newUser
  }

  LinkEventObjectToDraw(draw: Draw) {
    this.DataService.SelectedTorn!.events?.forEach(anEvent => {
        if (anEvent.id == draw.theEventID) {
            draw.theEvent = anEvent; //create event object for use later
        }
    })
  }

  createMatch(MatchNumber: number, tornId: number, drawId: number, Player1?: Player, Player2?: Player, Player3?: Player, Player4?: Player, RRNumber?: number, DateTime?: Date) {
    var NewMatch = new Match()
    NewMatch.matchNo = MatchNumber;
    var Draw = this.DataService.SelectedTorn!.draws?.find((d) => d.id == drawId);
    var Event = this.DataService.SelectedTorn!.events?.find((e) => e.id == Draw?.theEventID);
    if (Player1) {
        NewMatch.player1 = Player1.id;
        NewMatch.player1Name = Player1.name;
        if (Event?.type == 'Doubles' && !Player3) {
            const partner = this.getPartnerFromPlayer(Player1.id, Event.id);
            if (partner) {
                Player3 = partner;
            }
        }
        if (Player3) {
            NewMatch.player3 = Player3.id;
            NewMatch.player1Name = Player1.name + '/' + Player3.name;
            NewMatch.startPoints1 = Player1.doublesPoints;
            NewMatch.startPoints3 = Player3.doublesPoints;
        } else {
            NewMatch.startPoints1 = Player1.singlesPoints;
            NewMatch.startPoints3 = 0;
        }
    } else {
        NewMatch.player1Name = "";
    }
    if (Player2) {//if byes then match may not have all players yet
        NewMatch.player2 = Player2.id;
        NewMatch.player2Name = Player2.name;
        if (Event?.type == 'Doubles' && !Player4) {
            const partner = this.getPartnerFromPlayer(Player2.id, Event.id);
            if (partner) {
                Player4 = partner;
            }
        }
        if (Player4) {
            NewMatch.player4 = Player4.id;
            NewMatch.player2Name = Player2.name + '/' + Player4.name;
            NewMatch.startPoints2 = Player2.doublesPoints;
            NewMatch.startPoints4 = Player4.doublesPoints;
        } else {
            NewMatch.startPoints2 = Player2.singlesPoints;
            NewMatch.startPoints4 = 0;
        }
    } else {
        NewMatch.player2Name = "";
    }
    NewMatch.torn = tornId;
    NewMatch.draw = drawId;
    NewMatch.ttScore1 =  0;
    NewMatch.badScore1 =  0;
    NewMatch.squashScore1 =  0;
    NewMatch.tScore1 =  0;
    NewMatch.ttScore2 =  0;
    NewMatch.badScore2 =  0;
    NewMatch.squashScore2 =  0;
    NewMatch.tScore2 =  0;
    NewMatch.noTennis = false;

    if (DateTime) {
        NewMatch.dateOfMatch = DateTime;
    } else {
        NewMatch.dateOfMatch = new Date(this.DataService.SelectedTorn!.dateOfEvent!);//assign the date of the torn as it must be close
    }
    NewMatch.subDrawNumber = RRNumber;
    NewMatch.doNotProcess = false;
    return NewMatch
  }

//   InitNewDraw(newDraw) {
//     newDraw.Matches = [];
//     newDraw.Players1 = [];
//     newDraw.AvailablePlayers = [];
//     if (!newDraw.TheEvent) {
//         newDraw.TheEvent = {
//             Type: newDraw.Type,
//             Gender: newDraw.Gender
//         }
//     }
//     if (newDraw.format === "KO") {
//         if (newDraw.id > 1) {
//             var StartDayOfDraw = this.DataService.SelectedTorn.dateOfEvent;
//             if (this.DataService.SelectedTorn.doubles == "Sunday" && newDraw.TheEvent.Type == "Doubles" || this.DataService.SelectedTorn.doubles == "Saturday" && this.DataService.SelectedDraw.theEvent.type == "Singles") {
//                 StartDayOfDraw = this.addDays(1,this.DataService.SelectedTorn.dateOfEvent)
//                 //StartDayOfDraw = moment(this.DataService.SelectedTorn.dateOfEvent).add(1, 'd').toDate();
//             }
//             var DateTimeOfMatch;
//             for (var m = 1; m < 13; m++) {//create set ofes
//                 if ((m == 5 || m == 6 || m == 8 || m == 9)) {
//                     DateTimeOfMatch = this.addMinutes(StartDayOfDraw, this.DataService.SelectedTorn.MatchDuration);
//                     //DateTimeOfMatch = moment(StartDayOfDraw).add(this.DataService.SelectedTorn.MatchDuration, 'm').toDate();
//                 } else if (m == 7 || m > 9) {
//                     DateTimeOfMatch = this.addMinutes(StartDayOfDraw, (this.DataService.SelectedTorn.MatchDuration * 2)+ 30);
//                     //DateTimeOfMatch = moment(StartDayOfDraw).add((this.DataService.SelectedTorn.MatchDuration * 2) + 30, 'm').toDate();//adds an extra 30 mins for lunch
//                 } else {
//                     DateTimeOfMatch = StartDayOfDraw;
//                 }
//                 //var newMatcher = new Match();
//                 var newMatch = this.createMatch(m, this.DataService.SelectedTorn.id, newDraw.id, null, null, null, null, 1, DateTimeOfMatch);
//                 newDraw.Matches.push(newMatch);
//                 //newMatch.DateOfMatch = { value: new Date() };//convert it to a date object
//             }
//             this.APIService.SaveMatchCollection(newDraw.Matches);
//         }
//     } else if (newDraw.format === "PO") {
//         var DateTimeOfMatch2 = this.addMinutes(this.DataService.SelectedTorn.dateOfEvent, 430);
//         //var DateTimeOfMatch = moment(this.DataService.SelectedTorn.dateOfEvent).add(430, 'm').toDate();//make playoffs at 4pm
//         if (this.DataService.SelectedTorn.doubles == "Sunday" && newDraw.TheEvent.Type == "Doubles" || this.DataService.SelectedTorn.doubles == "Saturday" && newDraw.TheEvent.Type == "Singles") {
//             DateTimeOfMatch2 = this.addDays(1, DateTimeOfMatch2)
//             //DateTimeOfMatch2 = moment(DateTimeOfMatch).add(1, 'd').toDate();
//         }
//         for (m = 1; m < 4; m++) {//create set of matches
//             var newMatch = this.createMatch(m, this.DataService.SelectedTorn.id, newDraw.id, null, null, null, null, 1, DateTimeOfMatch);
//             newDraw.Matches.push(newMatch);
//             //newMatch.DateOfMatch = { value: new Date() };//convert it to a date object
//         }
//         this.APIService.SaveMatchCollection(newDraw.Matches);
//     }
//     //auto select new draw
//     //var DrawSelector = document.getElementById("DrawComboBox");
//     //DrawSelector.selectedIndex = this.DataService.SelectedTorn.Draws.length - offset;
//     this.DataService.SelectedTorn.draws.push(newDraw);
//     // if (this.DataService.SelectedDraw) {
//     //     if (newDraw.id == this.DataService.SelectedDraw.id) {
//     //         setTimeout(function () {
//     //             this.populateDraw();
//     //         }, 1000);
//     //     }
//     // }
//     this.DataService.TableRows1 = 3;
//     this.DataService.TableRows2 = 3;
//     //this.DataService.ManualInputText = "On";
//     this.DataService.SaveState();
//     return newDraw.id;
//     //return Promise.resolve(newDraw.id);
//     //return new Promise((resolve) => {
//     //    resolve(newDraw.id);
//     //});
//   }

//   ClearDraws() {
//     if (this.DataService.SelectedDraw) {
//         if (this.DataService.SelectedDraw.format === "RR") {
//             var TableBody = document.getElementById("TableBody1");
//             for (var row = 0; row < 6; row++) {
//                 for (var col = 1; col < this.DataService.TableRows1 + 2; col++) {
//                     var TheRow = TableBody.getElementsByTagName('tr')[row];
//                     var cellSelected = TheRow.getElementsByTagName('td')[col];
//                     if (cellSelected) {
//                         cellSelected.innerHTML = "";
//                     }
//                 }
//             }
//             TableBody = document.getElementById("TableBody2");//other subdraw
//             for (var row = 0; row < 6; row++) {
//                 for (var col = 1; col < this.DataService.TableRows2 + 2; col++) {
//                     var TheRow = TableBody.getElementsByTagName('tr')[row];
//                     var cellSelected = TheRow.getElementsByTagName('td')[col];
//                     if (cellSelected) {
//                         cellSelected.innerHTML = "";
//                     }
//                 }
//             }
//         }
//         if (this.DataService.SelectedTorn) {
//             this.PopulateAvailablePlayers(this.DataService.SelectedDraw);
//         }
//     }
//   }

  updateFontSizeInKO() {//could this be done with ngClass logic?!!?!?!?!?!
    //need to change size of font based on how many RRs
    if (this.DataService.SelectedDraw!.format == "RR") {
        var RRs = document.getElementsByClassName("TheRRDrawContainer");
        for (var r = 0; r < RRs.length; r++) {
            for (var tr = 0; tr < RRs[r].children[1].children[1].children.length; tr++) {
                var row = RRs[r].children[1].children[1].children[tr]
                for (var cell = 0; cell < RRs[r].children[1].children[1].children[tr].children.length; cell++) {
                    var TD = RRs[r].children[1].children[1].children[tr].children[cell];
                    if (this.DataService.SelectedDraw!.numberOfRRs! > 1) {
                        TD.classList.add("DoubleRR");
                    } else {
                        TD.classList.remove("DoubleRR");
                    }
                }
            }
        }
    } else if (this.DataService.SelectedDraw!.format == "KO") {
        setTimeout(() => {
            var KOLabels = document.getElementsByClassName("PlayersInMatch");
            for (var k = 0; k < KOLabels.length; k++) {
                if (this.DataService.SelectedDraw!.theEvent?.type == "Singles") {
                    KOLabels[k].classList.remove("Doubles");
                } else {
                    KOLabels[k].classList.add("Doubles");
                }
            }
        }, 100);
    }
    // var ScoreHover = document.getElementById("ScoreHover");
    // if (this.DataService.SelectedDraw!.theEvent?.type == "Singles") {
    //     ScoreHover.classList.remove("Doubles");
    // } else {
    //     ScoreHover.classList.add("Doubles");
    // }
}

updateNeedsToWin(TheMatch: Match) {
    this.DataService.NeedToWinString = '';
    //var TheMatch = this.SelectedMatch;
    if (TheMatch) {
        var P1Total = Number(TheMatch.ttScore1! + TheMatch.badScore1! + TheMatch.squashScore1! + TheMatch.tScore1!);
        var P2Total = Number(TheMatch.ttScore2! + TheMatch.badScore2! + TheMatch.squashScore2! + TheMatch.tScore2!);
        var NumberOfSportsPlayed = 0
        if ((TheMatch.ttScore1! + TheMatch.ttScore2!) > 0) {
            NumberOfSportsPlayed = NumberOfSportsPlayed + 1;
        }
        if ((TheMatch.badScore1! + TheMatch.badScore2!) > 0) {
            NumberOfSportsPlayed = NumberOfSportsPlayed + 1;
        }
        if ((TheMatch.squashScore1! + TheMatch.squashScore2!) > 0) {
            NumberOfSportsPlayed = NumberOfSportsPlayed + 1;
        }
        if ((TheMatch.tScore1! + TheMatch.tScore2!) > 0) {
            NumberOfSportsPlayed = NumberOfSportsPlayed + 1;
        }
        if (TheMatch.woWinner == 1) {
            this.DataService.NeedToWinString = TheMatch.player1Name + " has won by walkover";
        } else if (TheMatch.woWinner == 2) {
            this.DataService.NeedToWinString = TheMatch.player2Name + " has won by walkover";
        } else if (P1Total > 82) {
            this.DataService.NeedToWinString = TheMatch.player1Name + " has won by " + (P1Total - P2Total);
        } else if (P2Total > 82) {
            this.DataService.NeedToWinString = TheMatch.player2Name + " has won by " + (P2Total - P1Total);
        } else if ((P1Total - P2Total) > 21 && NumberOfSportsPlayed > 2) {
            this.DataService.NeedToWinString = TheMatch.player1Name + " has won by " + (P1Total - P2Total);
        } else if ((P2Total - P1Total) > 21 && NumberOfSportsPlayed > 2) {
            this.DataService.NeedToWinString = TheMatch.player2Name + " has won by " + (P2Total - P1Total);
        } else if (NumberOfSportsPlayed === 3 && P1Total > P2Total) {
            this.DataService.NeedToWinString = TheMatch.player1Name + " needs " + ((P2Total + 22) - P1Total) + " to win";
        } else if (NumberOfSportsPlayed === 3 && P2Total > P1Total) {
            this.DataService.NeedToWinString = TheMatch.player2Name + " needs " + ((P1Total + 22) - P2Total) + " to win";
        } else if (NumberOfSportsPlayed === 4 && P1Total > P2Total) {
            this.DataService.NeedToWinString = TheMatch.player1Name + " has won by " + (P1Total - P2Total);
        } else if (P1Total > P2Total) {
            this.DataService.NeedToWinString = TheMatch.player1Name + " is winning by " + (P1Total - P2Total);
        } else if (NumberOfSportsPlayed === 4 && P2Total > P1Total) {
            this.DataService.NeedToWinString = TheMatch.player2Name + " has won by " + (P2Total - P1Total);
        } else if (P2Total > P1Total) {
            this.DataService.NeedToWinString = TheMatch.player2Name + " is winning by " + (P2Total - P1Total);
        } else {
            this.DataService.NeedToWinString = "Match is currently a draw";
        }
    }
}

    assignPlayersToMatch(MatchNumber: number, Player1: Player, Player2: Player) {
    for (var n = 0; n < this.DataService.SelectedDraw!.Matches!.length; n++) {
        if (this.DataService.SelectedDraw!.Matches![n].matchNo == MatchNumber) {
            var TheMatch = this.DataService.SelectedDraw!.Matches![n];
            //this.DataService.SelectedMatch = this.DataService.SelectedDraw.Matches[n]
            if (Player1) {
                TheMatch.player1 = Player1.id;
            }
            if (Player2) {
                TheMatch.player2 = Player2.id;
            }
            if (this.DataService.SelectedDraw!.theEvent?.type === "Doubles") {
                if (Player1) {
                    TheMatch.player3 = Player1.Partner?.id;
                    TheMatch.player1Name = Player1.name + '/' + Player1.Partner?.name;
                }
                if (Player2) {
                    TheMatch.player4 = Player2.Partner?.id;
                    TheMatch.player2Name = Player2.name + '/' + Player2.Partner?.name;
                }
            } else {
                if (Player1) {
                    TheMatch.player1Name = Player1.name;
                }
                if (Player2) {
                    TheMatch.player2Name = Player2.name;
                }
            }
            this.APIService.updateMatch(TheMatch);
        }
    }
    this.DataService.SaveState();
}

    showScore(TheMatch: Match, label: HTMLElement, NameOnLabel: string) {
        var P1Total = Number(TheMatch.ttScore1! + TheMatch.badScore1! + TheMatch.squashScore1! + TheMatch.tScore1!);
        var P2Total = Number(TheMatch.ttScore2! + TheMatch.badScore2! + TheMatch.squashScore2! + TheMatch.tScore2!);
        var prefix = '';
        var SportsCompleted = 0
        if (TheMatch.ttScore1! + TheMatch.ttScore2! > 0) {
            SportsCompleted = SportsCompleted + 1;
        }
        if (TheMatch.badScore1! + TheMatch.badScore2! > 0) {
            SportsCompleted = SportsCompleted + 1;
        }
        if (TheMatch.squashScore1! + TheMatch.squashScore2! > 0) {
            SportsCompleted = SportsCompleted + 1;
        }
        if (TheMatch.tScore1! + TheMatch.tScore2! > 0) {
            SportsCompleted = SportsCompleted + 1;
        }
        var isComplete = false;
        if (SportsCompleted == 4 || (SportsCompleted == 3 && TheMatch.noTennis == true)) {
            isComplete = true;
        } else if (SportsCompleted == 3 && ((P1Total - P2Total) > 21 || (P1Total - P2Total) < -21)) {
            isComplete = true;
        }

        if (this.DataService.SelectedDraw!.format === "RR") {
            if (isComplete && ((TheMatch.player1Name === NameOnLabel && P1Total > P2Total) || (TheMatch.player2Name === NameOnLabel && P2Total > P1Total))) {
                prefix = "Won ";
            } else if (isComplete && ((TheMatch.player1Name === NameOnLabel && P2Total > P1Total) || (TheMatch.player2Name === NameOnLabel && P1Total > P2Total))) {
                prefix = "Lost ";
            } else if (isComplete) {
                prefix = "Draw ";
            } else {
                prefix = "";
            }
        }
        if (TheMatch.woWinner == 1 || TheMatch.woWinner == 2) {
            label.innerHTML = 'w/o';
        } else if (TheMatch.player1Name == 'BYE' || TheMatch.player2Name == 'BYE') {
            label.innerHTML = 'bye';
        } else {
            if (TheMatch.player1Name === NameOnLabel) {
                label.innerHTML = prefix + P1Total + '-' + P2Total;
            } else {
                label.innerHTML = prefix + P2Total + '-' + P1Total;
            }
        }
    }

    findWinner(match: Match) {
        //var player1Object;
        //var player2Object;
        var All4SportsHaveBeenPlayed = false;
        if ((match.ttScore1! > 0 || match.ttScore2! > 0) && (match.badScore1! > 0 || match.badScore2! > 0) && (match.squashScore1! > 0 || match.squashScore2! > 0) && (match.tScore1! > 0 || match.tScore2! > 0) ) {
            All4SportsHaveBeenPlayed = true;
        }
        var player1Score = Number(match.ttScore1) + Number(match.badScore1) + Number(match.squashScore1) + Number(match.tScore1);
        var player2Score = Number(match.ttScore2) + Number(match.badScore2) + Number(match.squashScore2) + Number(match.tScore2);
        if (player1Score > 0 && player2Score > 0) {
            match.Score = player1Score + ' - ' + player2Score;
        }
        //need to get player object to pass back....
        var player1Object = this.DataService.Players?.find((p) => p.id == match.player1) //getPlayerObject(match.player1, this.DataService.Players);
        var player2Object = this.DataService.Players?.find((p) => p.id == match.player2)
        //this.DataService.MatchScore = player1Score + '-' + player2Score;
        if (player1Object && player2Object) {
            if (match.woWinner == 1 || player2Object.name == 'BYE') {
                this.DataService.Loser = player2Object;
                return player1Object;
            } else if (match.woWinner == 2 || player1Object.name == 'BYE') {
                this.DataService.Loser = player1Object;
                return player2Object;
            } else if (player1Score > player2Score) {
                if (((player1Score - player2Score) > 21 || match.noTennis == true) || All4SportsHaveBeenPlayed == true) {
                    if (match.player3! > 0 && match.player4! > 0) {//if doubs
                        player1Object.Partner = this.DataService.Players?.find((p) => p.id == match.player3!)!//getPlayerObject(match.player3, this.DataService.Players).Name;//is this needed???
                        player2Object.Partner = this.DataService.Players?.find((p) => p.id == match.player4!)!
                    }
                    this.DataService.Loser = player2Object;
                    return player1Object;
                } else {
                    this.DataService.Loser = null as any;
                    return null;
                }
            } else if (player1Score < player2Score) {
                if (((player2Score - player1Score) > 21 || match.noTennis == true) || All4SportsHaveBeenPlayed == true) {// || All4SportsHaveBeenPlayed == true
                    if (match.player3! > 0 && match.player4! > 0) {//if doubs
                        player1Object.Partner = this.DataService.Players?.find((p) => p.id == match.player3!)!
                        player2Object.Partner = this.DataService.Players?.find((p) => p.id == match.player4!)!
                    }
                    this.DataService.Loser = player1Object;
                    return player2Object;
                } else {
                    this.DataService.Loser = null as any;
                    return null;
                }
            } else {
                this.DataService.Loser = null as any;
                return null;
            }
        } else {
            this.DataService.Loser = null as any;
            return null;
        }
      }

    //   checkForNewMatchPosibilites() {
    //     if (this.DataService.SelectedDraw.format === "KO") {
    //         var Match1;//these should be all created at the start for KO's
    //         var Match2;
    //         var Match3;
    //         var Match4;
    //         var Semi1;
    //         var Semi2;
    //         var Final;
    //         var PlateSemi1;
    //         var PlateSemi2;
    //         var PlateFinal;
    //         for (var m = 0; m < this.DataService.SelectedDraw.Matches.length; m++) {
    //             if (this.DataService.SelectedDraw.Matches[m].matchNo === 1) {
    //                 Match1 = this.DataService.SelectedDraw.Matches[m];
    //             }
    //             if (this.DataService.SelectedDraw.Matches[m].matchNo === 2) {
    //                 Match2 = this.DataService.SelectedDraw.Matches[m];
    //             }
    //             if (this.DataService.SelectedDraw.Matches[m].matchNo === 3) {
    //                 Match3 = this.DataService.SelectedDraw.Matches[m];
    //             }
    //             if (this.DataService.SelectedDraw.Matches[m].matchNo === 4) {
    //                 Match4 = this.DataService.SelectedDraw.Matches[m];
    //             }
    //             if (this.DataService.SelectedDraw.Matches[m].matchNo === 5) {
    //                 Semi1 = this.DataService.SelectedDraw.Matches[m];
    //             }
    //             if (this.DataService.SelectedDraw.Matches[m].matchNo === 6) {
    //                 Semi2 = this.DataService.SelectedDraw.Matches[m];
    //             }
    //             if (this.DataService.SelectedDraw.Matches[m].matchNo === 7) {
    //                 Final = this.DataService.SelectedDraw.Matches[m];
    //             }
    //             if (this.DataService.SelectedDraw.Matches[m].matchNo === 8) {
    //                 PlateSemi1 = this.DataService.SelectedDraw.Matches[m];
    //             }
    //             if (this.DataService.SelectedDraw.Matches[m].matchNo === 9) {
    //                 PlateSemi2 = this.DataService.SelectedDraw.Matches[m];
    //             }
    //             if (this.DataService.SelectedDraw.Matches[m].matchNo === 10) {
    //                 PlateFinal = this.DataService.SelectedDraw.Matches[m];
    //             }
    //         }//check 5th match - first Semi:
    //         if (Match1 && Match2) {
    //             var Winner1 = this.findWinner(Match1);
    //             var Loser1 = this.DataService.Loser;
    //             var Winner2 = this.findWinner(Match2);
    //             var Loser2 = this.DataService.Loser;
    //             if (Winner1 && Winner2 && Semi1) {
    //                 this.assignPlayersToMatch(5, Winner1, Winner2);
    //                 this.assignPlayersToMatch(8, Loser1, Loser2);//assign losers as well:
    //             } //check 6th match - 2nd Semi:
    //         }
    //         if (Match3 && Match4) {
    //             var Winner1 = this.findWinner(Match3);
    //             var Loser1 = this.DataService.Loser;
    //             var Winner2 = this.findWinner(Match4);
    //             var Loser2 = this.DataService.Loser;
    //             if (Winner1 && Winner2 && Semi2) {
    //                 this.assignPlayersToMatch(6, Winner1, Winner2);
    //                 this.assignPlayersToMatch(9, Loser1, Loser2);//assign losers as well:
    //             } //check 7th match - Final:
    //             if (Semi1 && Semi2) {
    //                 var Winner1 = this.findWinner(Semi1);
    //                 var Loser1 = this.DataService.Loser;
    //                 var Winner2 = this.findWinner(Semi2);
    //                 var Loser2 = this.DataService.Loser;
    //                 if (Winner1 && Winner2 && Final) {
    //                     this.assignPlayersToMatch(7, Winner1, Winner2);
    //                     this.assignPlayersToMatch(11, Loser1, Loser2);
    //                 }
    //             }
    //             if (PlateSemi1 && PlateSemi2) {
    //                 var Winner1 = this.findWinner(PlateSemi1);
    //                 var Loser1 = this.DataService.Loser;
    //                 var Winner2 = this.findWinner(PlateSemi2);
    //                 var Loser2 = this.DataService.Loser;
    //                 if (Winner1 && Winner2 && PlateFinal) {
    //                     this.assignPlayersToMatch(10, Winner1, Winner2);
    //                     this.assignPlayersToMatch(12, Loser1, Loser2);
    //                 }
    //             }
    //         }
    //     } else if (this.DataService.SelectedDraw.format === "PO") {//Playoffs
    //         if (this.DataService.SelectedDraw.Matches.length < 3) {
    //             var MatchList = [];
    //             var MatchesToSave = [];
    //             for (var l = 1; l < 4; l++) {
    //                 var label1 = document.getElementById("POLabel" + ((l * 2) - 1));
    //                 var label2 = document.getElementById("POLabel" + l * 2);
    //                 if (label1 && label2) {
    //                     if (label1.innerHTML != '' && label2.innerHTML != '') {
    //                     }
    //                 }
    //             }
    //             var BoolAlreadyExists = false;
    //             for (var ml = 0; ml < MatchList.length; ml++) {
    //                 for (m = 0; m < this.DataService.SelectedDraw.Matches.length; m++) {
    //                     if (MatchList[ml].matchNo == this.DataService.SelectedDraw.Matches[m].matchNo) {
    //                         BoolAlreadyExists = true
    //                     }
    //                 }
    //                 if (BoolAlreadyExists == false) {
    //                     MatchesToSave.push(MatchList[ml]);
    //                 }
    //                 BoolAlreadyExists = false;
    //             }
    //         }
    //         if (MatchesToSave) {
    //             if (MatchesToSave.length > 0) {
    //                 this.APIService.SaveMatchCollection(MatchesToSave);
    //             }
    //         }
    //     } else if (this.DataService.SelectedDraw.format === "RR") {//RR
    //         if ((this.DataService.Selecteddraw.Players1!.length + this.DataService.Selecteddraw.Players2!.length) > 5 && (this.DataService.Selecteddraw.Players1!.length + this.DataService.Selecteddraw.Players2!.length) < 8) {
    //             this.recreatePlacings();
    //             if (this.isRoundRobinFinished(this.DataService.SelectedDraw.Places1) == true && this.isRoundRobinFinished(this.DataService.SelectedDraw.Places2) == true) {
    //                 this.DataService.NormalLimit = this.CalcNormalLimit(this.DataService.SelectedDraw);
    //                 this.FillRRPlayOffs();
    //             }
    //         }

    //     }
    //     this.DataService.SaveState();
    // }

    assignPlayersToNextRound(draw: Draw, match: Match) { //this will assign the player to the next round
        draw.Matches = draw.Matches!//insists that matches is not null but it should never be null as it is created at the start of the draw creation process
        if (draw.format == 'KO' && match.Winner && match.Loser) {
            if (draw.Players1!.length == 4) {
                if (match.matchNo == 1) {
                    draw.Matches[4].player1 = match.Winner.id; //Final
                    draw.Matches[4].player1Name = match.Winner.name; //Final
                    if (match.Winner.Partner) {
                        draw.Matches[4].player3 = match.Winner.Partner.id; //Final
                        draw.Matches[4].player1Name = match.Winner.name + '/' + match.Winner.Partner.name; //Final
                    }
                    draw.Matches[3].player1 = match.Loser.id; //plate Final
                    draw.Matches[3].player1Name = match.Loser.name; //plate Final
                    if (match.Loser.Partner) {
                        draw.Matches[3].player3 = match.Loser.Partner.id; //plate Final
                        draw.Matches[3].player1Name = match.Loser.name + '/' + match.Loser.Partner.name; //plate Final
                    }
                } else if (match.matchNo == 2) {
                    draw.Matches[4].player2 = match.Winner.id; //Final
                    draw.Matches[4].player2Name = match.Winner.name; //Final
                    if (match.Winner.Partner) {
                        draw.Matches[4].player4 = match.Winner.Partner.id; //Final
                        draw.Matches[4].player2Name = match.Winner.name + '/' + match.Winner.Partner.name; //Final
                    }
                    draw.Matches[3].player2 = match.Loser.id; //plate Final
                    draw.Matches[3].player2Name = match.Loser.name; //plate Final
                    if (match.Loser.Partner) {
                        draw.Matches[3].player4 = match.Loser.Partner.id; //plate Final
                        draw.Matches[3].player2Name = match.Loser.name + '/' + match.Loser.Partner.name; //plate Final
                    }
                }
                this.APIService.updateMatch(draw.Matches[3]);
                this.APIService.updateMatch(draw.Matches[4]);
            } else if (draw.Players1!.length == 8) {
                if (match.matchNo == 1) {//Round 1 Match 1
                    this.AssignIDAndNumberToNewMatch(draw.Matches[7], draw.Matches[5], match, 1);//Semi1 & Plate Semi1
                } else if (match.matchNo == 2) {//Round 1 Match 2
                    this.AssignIDAndNumberToNewMatch(draw.Matches[7], draw.Matches[5], match, 2);//Semi1 & Plate Semi1
                } else if (match.matchNo == 3) {//Round 1 Match 3
                    this.AssignIDAndNumberToNewMatch(draw.Matches[8], draw.Matches[6], match, 1);//Semi2 & Plate Semi2
                } else if (match.matchNo == 4) {//Round 1 Match 4
                    this.AssignIDAndNumberToNewMatch(draw.Matches[8], draw.Matches[6], match, 2);//Semi2 & Plate Semi2
                } else if (match.matchNo == 5) {//Plate Semi1
                    this.AssignIDAndNumberToNewMatch(draw.Matches[10], draw.Matches[9], match, 1);//Plate Final & Consolation Plate Final
                } else if (match.matchNo == 6) {//Plate Semi2
                    this.AssignIDAndNumberToNewMatch(draw.Matches[10], draw.Matches[9], match, 2);//Plate Final & Consolation Plate Final
                } else if (match.matchNo == 7) {//Semi1
                    this.AssignIDAndNumberToNewMatch(draw.Matches[12], draw.Matches[11], match, 1);//Final & Special Plate Final
                } else if (match.matchNo == 8) {//Semi2
                    this.AssignIDAndNumberToNewMatch(draw.Matches[12], draw.Matches[11], match, 2);//Final & Special Plate Final
                }
            } else if (draw.Players1!.length > 8 &&draw.Players1!.length < 17) {
                if (match.matchNo == 1) {//Round 1 Match 1
                    this.AssignIDAndNumberToNewMatch(draw.Matches![13], draw.Matches[9], match, 1);//Qtr1 & Plate Qtr1 - if match 1 then is 16 draw
                } else if (match.matchNo == 2) {//Round 1 Match 2
                    if (draw.Players1!.length == 16) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[13], draw.Matches[9], match, 2);//Qtr1 & Plate Qtr1
                    } else if (draw.Players1!.length > 11) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[13], draw.Matches[19], match, 2, 1);//Qtr1 & Plate Semi1 - needs to be plate semi player 1!
                    } else if (draw.Players1!.length > 9) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[13], draw.Matches[28], match, 2, 1);//Qtr1 & Plate Final
                    } else {
                        //this.AssignIDAndNumberToNewMatch(draw.Matches[13], null, match, 2);//Qtr1 & no more matches if only 9 players
                    }
                } else if (match.matchNo == 3) {//Round 1 Match 3
                    if (draw.Players1!.length > 12) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[14], draw.Matches[10], match, 1);//Qtr2 & Plate Qtr2
                    } else {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[14], draw.Matches[19], match, 2);//Qtr2 & Plate Semi1
                    }
                } else if (match.matchNo == 4) {//Round 1 Match 4
                    if (draw.Players1!.length > 12) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[14], draw.Matches[10], match, 2);//Qtr2 & Plate Qtr2
                    } else {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[14], draw.Matches[19], match, 2);//Qtr2 & Plate Semi1
                    }
                } else if (match.matchNo == 5) {//Round 1 Match 5
                    if (draw.Players1!.length > 13) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[15], draw.Matches[11], match, 1);//Qtr3 & Plate Qtr3
                    } else {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[15], draw.Matches[20], match, 1,2);//Qtr3 & Plate Semi2
                    }
                } else if (match.matchNo == 6) {//Round 1 Match 6
                    if (draw.Players1!.length > 13) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[15], draw.Matches[11], match, 2);//Qtr3 & Plate Qtr3
                    } else {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[15], draw.Matches[20], match, 2, 1);//Qtr3 & Plate Semi2
                    }
                } else if (match.matchNo == 7) {//Round 1 Match 7
                    if (draw.Players1!.length > 14) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[16], draw.Matches[12], match, 1);//Qtr4 & Plate Qtr4
                    } else if (draw.Players1!.length > 10) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[16], draw.Matches[20], match, 1,2);//Qtr4 & Plate Semi2
                    } else {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[16], draw.Matches[28], match, 1,2);//Qtr4 & Plate Final
                    }
                } else if (match.matchNo == 8) {//Round 1 Match 8
                    this.AssignIDAndNumberToNewMatch(draw.Matches[16], draw.Matches[12], match, 2);//Qtr4 & Plate Qtr4 - if match 8 then is 15+ draw
                } else if (match.matchNo == 9) {//Plate Qtr1
                    this.AssignIDAndNumberToNewMatch(draw.Matches[19], draw.Matches[17], match, 1);//Plate Semi1 & Consolation Plate Semi1
                } else if (match.matchNo == 10) {//Plate Qtr2
                    if (draw.Players1!.length > 15) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[19], draw.Matches[17], match, 2);//Plate Semi1 & Consolation Plate Semi1
                    } else {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[19], draw.Matches[26], match, 2, 1);//Plate Semi1 & Consolation Plate Semi1
                    }
                } else if (match.matchNo == 11) {//Plate Qtr3
                    if (draw.Players1!.length > 14) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[20], draw.Matches[18], match, 1);//Plate Semi2 & Consolation Plate Semi2
                    } else {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[20], draw.Matches[26], match, 1,2);//Plate Final & 11-12th Place
                    }
                } else if (match.matchNo == 12) {//Plate Qtr4
                    this.AssignIDAndNumberToNewMatch(draw.Matches[20], draw.Matches[18], match, 1);//Plate Semi2 & Consolation Plate Semi2
                } else if (match.matchNo == 13) {//Qtr1
                    this.AssignIDAndNumberToNewMatch(draw.Matches[23], draw.Matches[21], match, 1);//Semi1 & Special Plate Semi1
                } else if (match.matchNo == 14) {//Qtr2
                    this.AssignIDAndNumberToNewMatch(draw.Matches[23], draw.Matches[21], match, 2);//Semi1 & Special Plate Semi1
                } else if (match.matchNo == 15) {//Qtr3
                    this.AssignIDAndNumberToNewMatch(draw.Matches[24], draw.Matches[22], match, 1);//Semi2 & Special Plate Semi2
                } else if (match.matchNo == 16) {//Qtr4
                    this.AssignIDAndNumberToNewMatch(draw.Matches[24], draw.Matches[22], match, 2);//Semi2 & Special Plate Semi2
                } else if (match.matchNo == 17) {//Consolation Plate Semi1
                    this.AssignIDAndNumberToNewMatch(draw.Matches[26], draw.Matches[25], match, 1);//Consolation Plate Final & 15-16th Place
                } else if (match.matchNo == 18) {//Consolation Plate Semi2
                    this.AssignIDAndNumberToNewMatch(draw.Matches[26], draw.Matches[25], match, 2);//Consolation Plate Final & 15-16th Place
                } else if (match.matchNo == 19) {//Plate Semi1
                    this.AssignIDAndNumberToNewMatch(draw.Matches[28], draw.Matches[27], match, 1);//Plate Final & 11-12th Place
                } else if (match.matchNo == 20) {//Plate Semi2
                    this.AssignIDAndNumberToNewMatch(draw.Matches[28], draw.Matches[27], match, 2);//Plate Final & 11-12th Place
                } else if (match.matchNo == 21) {//Special Plate Semi1
                    this.AssignIDAndNumberToNewMatch(draw.Matches[30], draw.Matches[29], match, 1);//Special Plate Final & 7-8th Place
                } else if (match.matchNo == 22) {//Special Plate Semi2
                    this.AssignIDAndNumberToNewMatch(draw.Matches[30], draw.Matches[29], match, 2);//Special Plate Final & 7-8th Place
                } else if (match.matchNo == 23) {//Semi1
                    this.AssignIDAndNumberToNewMatch(draw.Matches[32], draw.Matches[31], match, 1);//Final & Bronze Final
                } else if (match.matchNo == 24) {//Semi2
                    this.AssignIDAndNumberToNewMatch(draw.Matches[32], draw.Matches[31], match, 2);//Final & Bronze Final
                }
            } else if (draw.Players1!.length > 16 && draw.Players1!.length < 33) {
                if (match.matchNo == 1) {//Round 1 Match 1
                    this.AssignIDAndNumberToNewMatch(draw.Matches[25], draw.Matches[17], match, 1);//R161 & Plate R161 - if there is match 1 then is 32 draw
                } else if (match.matchNo == 2) {//Round 1 Match 2
                    if (draw.Players1!.length > 31) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[25], draw.Matches[17], match, 2);//R161 & Plate R161
                    } else if (draw.Players1!.length > 20) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[25], draw.Matches[37], match, 2,1);//R161 & Plate Qtr
                    } else  {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[25], draw.Matches[72], match, 2, 1);//R161 & Plate Semi
                    }
                } else if (match.matchNo == 3) {//Round 1 Match 3
                    if (draw.Players1!.length > 24) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[26], draw.Matches[18], match, 1);//R162 & Plate R162
                    } else  {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[26], draw.Matches[37], match, 1,2);//R162 & Plate Qtr
                    }
                } else if (match.matchNo == 4) {//Round 1 Match 4
                    this.AssignIDAndNumberToNewMatch(draw.Matches[26], draw.Matches[18], match, 2);//R162 & Plate R162
                } else if (match.matchNo == 5) {//Round 1 Match 5
                    this.AssignIDAndNumberToNewMatch(draw.Matches[27], draw.Matches[19], match, 1);//R163 & Plate R163
                } else if (match.matchNo == 6) {//Round 1 Match 6
                    if (draw.Players1!.length > 27) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[27], draw.Matches[19], match, 2);//R163 & Plate R163
                    } else {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[27], draw.Matches[38], match, 2,1);//R163 & Plate Qtr2
                    }
                } else if (match.matchNo == 7) {//Round 1 Match 7
                    if (draw.Players1!.length > 28) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[28], draw.Matches[20], match, 1);//R164 & Plate R164
                    } else {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[28], draw.Matches[38], match, 1,2);//R164 & Plate Qtr2
                    }
                } else if (match.matchNo == 8) {//Round 1 Match 8
                    this.AssignIDAndNumberToNewMatch(draw.Matches[28], draw.Matches[20], match, 2);//R164 & Plate R164
                } else if (match.matchNo == 9) {//Round 1 Match 9
                    this.AssignIDAndNumberToNewMatch(draw.Matches[29], draw.Matches[21], match, 1);//R165 & Plate R165
                } else if (match.matchNo == 10) {//Round 1 Match 10
                    if (draw.Players1!.length > 29) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[29], draw.Matches[21], match, 2);//R165 & Plate R165
                    } else if (draw.Players1!.length > 21) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[29], draw.Matches[39], match, 2,1);//R165 & Plate Qtr3
                    } else if (draw.Players1!.length > 18) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[29], draw.Matches[56], match, 2, 1);//R165 & Plate Semi2
                    } else {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[29], draw.Matches[72], match, 2);//R165 & Plate Final
                    }
                } else if (match.matchNo == 11) {//Round 1 Match 11
                    if (draw.Players1!.length > 26) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[30], draw.Matches[22], match, 1);//R166 & Plate R166
                    } else {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[30], draw.Matches[39], match, 1,2);//R166 & Plate Qtr3
                    } 
                } else if (match.matchNo == 12) {//Round 1 Match 12
                    if (draw.Players1!.length > 26) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[30], draw.Matches[22], match, 2);//R166 & Plate R166
                    } else {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[30], draw.Matches[39], match, 2);//R166 & Plate Qtr3
                    } 
                } else if (match.matchNo == 13) {//Round 1 Match 13
                    this.AssignIDAndNumberToNewMatch(draw.Matches[31], draw.Matches[23], match, 1);//R167 & Plate R167
                } else if (match.matchNo == 14) {//Round 1 Match 14
                    if (draw.Players1!.length > 25) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[31], draw.Matches[23], match, 2);//R167 & Plate R167
                    } else if (draw.Players1!.length > 23) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[31], draw.Matches[40], match, 2,1);//R167 & Plate Final
                    } else {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[31], draw.Matches[72], match, 2,2);//R167 & Plate Final
                    }
                } else if (match.matchNo == 15) {//Round 1 Match 15
                    if (draw.Players1!.length > 30) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[32], draw.Matches[24], match, 1);//R168 & Plate R168
                    } else if (draw.Players1!.length > 22) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[32], draw.Matches[40], match, 1,2);//R168 & Plate Qtr4
                    } else {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[32], draw.Matches[72], match, 1,2);//R168 & Plate Final
                    }
                } else if (match.matchNo == 16) {//Round 1 Match 16
                        this.AssignIDAndNumberToNewMatch(draw.Matches[32], draw.Matches[24], match, 2);//R168 & Plate R168
                } else if (match.matchNo == 17) {//Plate R161
                    this.AssignIDAndNumberToNewMatch(draw.Matches[37], draw.Matches[33], match, 1);//Plate Qtr1 & Consolation Plate Qtr1
                } else if (match.matchNo == 18) {//Plate R162
                    if (draw.Players1!.length > 31) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[37], draw.Matches[33], match, 2);//Plate Qtr1 & Consolation Plate Qtr1
                    } else {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[37], draw.Matches[51], match, 2,1);//Plate Qtr1 & Consolation Plate Qtr2
                    }
                } else if (match.matchNo == 19) {//Plate R163
                    if (draw.Players1!.length > 28) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[38], draw.Matches[34], match, 1);//Plate Qtr2 & Consolation Plate Qtr2
                    } else {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[38], draw.Matches[51], match, 1,2);//Plate Qtr2 & Consolation Plate Qtr2
                    }
                } else if (match.matchNo == 20) {//Plate R164
                    this.AssignIDAndNumberToNewMatch(draw.Matches[38], draw.Matches[34], match, 2);//Plate Qtr2 & Consolation Plate Qtr2
                } else if (match.matchNo == 21) {//Plate R165
                    this.AssignIDAndNumberToNewMatch(draw.Matches[39], draw.Matches[35], match, 1);//Plate Qtr3 & Consolation Plate Qtr3
                } else if (match.matchNo == 22) {//Plate R166
                    if (draw.Players1!.length > 29) {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[39], draw.Matches[35], match, 2);//Plate Qtr3 & Consolation Plate Qtr3
                    } else {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[39], draw.Matches[52], match, 2);//Plate Qtr3 & Consolation Plate Qtr3
                    }
                } else if (match.matchNo == 23) {//Plate R167
                    if (draw.Players1!.length > 31) {
                    this.AssignIDAndNumberToNewMatch(draw.Matches[40], draw.Matches[36], match, 1);//Plate Qtr4 & Consolation Plate Qtr4
                    } else {
                        this.AssignIDAndNumberToNewMatch(draw.Matches[40], draw.Matches[52], match, 1,2);//Plate Qtr4 & Consolation Plate Qtr4
                    }
                } else if (match.matchNo == 24) {//Plate R168
                    this.AssignIDAndNumberToNewMatch(draw.Matches[40], draw.Matches[36], match, 2);//Plate Qtr4 & Consolation Plate Qtr4
                } else if (match.matchNo == 25) {//R161
                    this.AssignIDAndNumberToNewMatch(draw.Matches[45], draw.Matches[41], match, 1);//Qtr1 & Special Plate Qtr1
                } else if (match.matchNo == 26) {//R161
                    this.AssignIDAndNumberToNewMatch(draw.Matches[45], draw.Matches[41], match, 2);//Qtr1 & Special Plate Qtr1
                } else if (match.matchNo == 27) {//R161
                    this.AssignIDAndNumberToNewMatch(draw.Matches[46], draw.Matches[42], match, 1);//Qtr2 & Special Plate Qtr2
                } else if (match.matchNo == 28) {//R161
                    this.AssignIDAndNumberToNewMatch(draw.Matches[46], draw.Matches[42], match, 2);//Qtr2 & Special Plate Qtr2
                } else if (match.matchNo == 29) {//R161
                    this.AssignIDAndNumberToNewMatch(draw.Matches[47], draw.Matches[43], match, 1);//Qtr3 & Special Plate Qtr3
                } else if (match.matchNo == 30) {//R161
                    this.AssignIDAndNumberToNewMatch(draw.Matches[47], draw.Matches[43], match, 2);//Qtr3 & Special Plate Qtr3
                } else if (match.matchNo == 31) {//R161
                    this.AssignIDAndNumberToNewMatch(draw.Matches[48], draw.Matches[44], match, 1);//Qtr4 & Special Plate Qtr4
                } else if (match.matchNo == 32) {//R161
                    this.AssignIDAndNumberToNewMatch(draw.Matches[48], draw.Matches[44], match, 2);//Qtr4 & Special Plate Qtr4

                } else if (match.matchNo == 33) {//Cons Qtrs
                    this.AssignIDAndNumberToNewMatch(draw.Matches[51], draw.Matches[49], match, 1);//Cons Semi1 & 29-32th Place 1
                } else if (match.matchNo == 34) {//Cons Qtrs
                    this.AssignIDAndNumberToNewMatch(draw.Matches[51], draw.Matches[49], match, 2);//Cons Semi1 & 29-32th Place 1
                } else if (match.matchNo == 35) {//Cons Qtrs
                    this.AssignIDAndNumberToNewMatch(draw.Matches[52], draw.Matches[50], match, 1);//Cons Semi2 & 29-32th Place 2
                } else if (match.matchNo == 36) {//Cons Qtrs
                    this.AssignIDAndNumberToNewMatch(draw.Matches[52], draw.Matches[50], match, 2);//Cons Semi2 & 29-32th Place 2
                } else if (match.matchNo == 37) {//Plate Qtrs
                    this.AssignIDAndNumberToNewMatch(draw.Matches[55], draw.Matches[53], match, 1);//Plate Semi1 & 24-24 Semi 1
                } else if (match.matchNo == 38) {//Plate Qtrs
                    this.AssignIDAndNumberToNewMatch(draw.Matches[55], draw.Matches[53], match, 2);//Plate Semi1 & 24-24 Semi 1
                } else if (match.matchNo == 39) {//Plate Qtrs
                    this.AssignIDAndNumberToNewMatch(draw.Matches[56], draw.Matches[54], match, 1);//Plate Semi2 & 24-24 Semi 2
                } else if (match.matchNo == 40) {//Plate Qtrs
                    this.AssignIDAndNumberToNewMatch(draw.Matches[56], draw.Matches[54], match, 2);//Plate Semi2 & 24-24 Semi 2
                } else if (match.matchNo == 41) {//Special Plate Qtrs
                    this.AssignIDAndNumberToNewMatch(draw.Matches[59], draw.Matches[57], match, 1);//Special Plate Semi1 & 13-16 Semi 1
                } else if (match.matchNo == 42) {//Special Plate Qtrs
                    this.AssignIDAndNumberToNewMatch(draw.Matches[59], draw.Matches[57], match, 2);//Special Plate Semi1 & 13-16 Semi 1
                } else if (match.matchNo == 43) {//Special Plate Qtrs
                    this.AssignIDAndNumberToNewMatch(draw.Matches[60], draw.Matches[58], match, 1);//Special Plate Semi2 & 13-16 Semi 2
                } else if (match.matchNo == 44) {//Special Plate Qtrs
                    this.AssignIDAndNumberToNewMatch(draw.Matches[60], draw.Matches[58], match, 2);//Special Plate Semi2 & 13-16 Semi 2
                } else if (match.matchNo == 45) {// Qtrs
                    this.AssignIDAndNumberToNewMatch(draw.Matches[63], draw.Matches[61], match, 1);// Semi1 & 5-8 Semi 1
                } else if (match.matchNo == 46) {// Qtrs
                    this.AssignIDAndNumberToNewMatch(draw.Matches[63], draw.Matches[61], match, 2);// Semi1 & 5-8 Semi 1
                } else if (match.matchNo == 47) {// Qtrs
                    this.AssignIDAndNumberToNewMatch(draw.Matches[64], draw.Matches[62], match, 1);// Semi2 & 5-8 Semi 2
                } else if (match.matchNo == 48) {// Qtrs
                    this.AssignIDAndNumberToNewMatch(draw.Matches[64], draw.Matches[62], match, 2);// Semi2 & 5-8 Semi 2

                } else if (match.matchNo == 49) {// 29-32 POs
                    this.AssignIDAndNumberToNewMatch(draw.Matches[66], draw.Matches[65], match, 1);// 29-30 Final & 31-32 Final
                } else if (match.matchNo == 50) {// 29-32 POs
                    this.AssignIDAndNumberToNewMatch(draw.Matches[66], draw.Matches[65], match, 2);// 29-30 Final & 31-32 Final
                } else if (match.matchNo == 51) {//Conso Semis
                    this.AssignIDAndNumberToNewMatch(draw.Matches[68], draw.Matches[67], match, 1);// Conso Final & 27-28 Final
                } else if (match.matchNo == 52) {//Conso Semis
                    this.AssignIDAndNumberToNewMatch(draw.Matches[68], draw.Matches[67], match, 2);// Conso Final & 27-28 Final
                } else if (match.matchNo == 53) {//21-24 Semis
                    this.AssignIDAndNumberToNewMatch(draw.Matches[70], draw.Matches[69], match, 1);// 21-22 & 23-24
                } else if (match.matchNo == 54) {//21-24 Semis
                    this.AssignIDAndNumberToNewMatch(draw.Matches[70], draw.Matches[69], match, 2);// 21-22 & 23-24
                } else if (match.matchNo == 55) {//Plate Semis
                    this.AssignIDAndNumberToNewMatch(draw.Matches[72], draw.Matches[71], match, 1);// Plate Final & 19-20
                } else if (match.matchNo == 56) {//Plate Semis
                    this.AssignIDAndNumberToNewMatch(draw.Matches[72], draw.Matches[71], match, 2);// Plate Final & 19-20
                } else if (match.matchNo == 57) {//13-16 POs
                    this.AssignIDAndNumberToNewMatch(draw.Matches[74], draw.Matches[73], match, 1);// 13-14 & 15-16
                } else if (match.matchNo == 58) {//13-16 POs
                    this.AssignIDAndNumberToNewMatch(draw.Matches[74], draw.Matches[73], match, 2);// 13-14 & 15-16
                } else if (match.matchNo == 59) {//Special Plate Semis
                    this.AssignIDAndNumberToNewMatch(draw.Matches[76], draw.Matches[75], match, 1);// Special Plate Final & 9-10th Place
                } else if (match.matchNo == 60) {//Special Plate Semis
                    this.AssignIDAndNumberToNewMatch(draw.Matches[76], draw.Matches[75], match, 2);// Special Plate Final & 9-10th Place
                } else if (match.matchNo == 61) {//5-8 Semis
                    this.AssignIDAndNumberToNewMatch(draw.Matches[78], draw.Matches[77], match, 1);// 5-6 & 7-8th Place
                } else if (match.matchNo == 62) {//5-8 Semis
                    this.AssignIDAndNumberToNewMatch(draw.Matches[78], draw.Matches[77], match, 2);// 5-6 & 7-8th Place
                } else if (match.matchNo == 63) {// Semis
                    this.AssignIDAndNumberToNewMatch(draw.Matches[80], draw.Matches[79], match, 1);// Final & Bronze Final
                } else if (match.matchNo == 64) {// Semis
                    this.AssignIDAndNumberToNewMatch(draw.Matches[80], draw.Matches[79], match, 2);// Final & Bronze Final
                }
            // } else if (draw.Players1!.length == 32) {
            //     var DS = 32;
            //     if (match.matchNo > 0 && match.matchNo < 17) {//Round 1 Matches 1-16
            //         if (this.isOdd(match.matchNo)) {
            //             this.AssignIDAndNumberToNewMatch(draw.Matches[(DS/2)+(DS/4)+ match.matchNo], draw.Matches[(DS/2)+match.matchNo], match, 1);//R161 & Plate R161
            //         } else {
            //             this.AssignIDAndNumberToNewMatch(draw.Matches[(DS/2)+(DS/4)+ match.matchNo], draw.Matches[(DS/2)+match.matchNo], match, 2);//R162 & Plate R162
            //         }
            //     }

            //     if (match.matchNo == 17) {//Plate R161
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[37], draw.Matches[33], match, 1);//Plate Qtr1 & Consolation Plate Qtr1
            //     } else if (match.matchNo == 18) {//Plate R162
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[37], draw.Matches[33], match, 2);//Plate Qtr1 & Consolation Plate Qtr1
            //     } else if (match.matchNo == 19) {//Plate R163
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[38], draw.Matches[34], match, 1);//Plate Qtr2 & Consolation Plate Qtr2
            //     } else if (match.matchNo == 20) {//Plate R164
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[38], draw.Matches[34], match, 2);//Plate Qtr2 & Consolation Plate Qtr2
            //     } else if (match.matchNo == 21) {//Plate R165
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[39], draw.Matches[35], match, 1);//Plate Qtr3 & Consolation Plate Qtr3
            //     } else if (match.matchNo == 22) {//Plate R166
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[39], draw.Matches[35], match, 2);//Plate Qtr3 & Consolation Plate Qtr3
            //     } else if (match.matchNo == 23) {//Plate R167
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[40], draw.Matches[36], match, 1);//Plate Qtr4 & Consolation Plate Qtr4
            //     } else if (match.matchNo == 24) {//Plate R168
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[40], draw.Matches[36], match, 2);//Plate Qtr4 & Consolation Plate Qtr4
            //     } else if (match.matchNo == 25) {//R161
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[45], draw.Matches[41], match, 2);//Qtr1 & Special Plate Qtr1
            //     } else if (match.matchNo == 26) {//R161
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[45], draw.Matches[41], match, 1);//Qtr1 & Special Plate Qtr1
            //     } else if (match.matchNo == 27) {//R161
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[46], draw.Matches[42], match, 2);//Qtr2 & Special Plate Qtr2
            //     } else if (match.matchNo == 28) {//R161
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[46], draw.Matches[42], match, 1);//Qtr2 & Special Plate Qtr2
            //     } else if (match.matchNo == 29) {//R161
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[47], draw.Matches[43], match, 2);//Qtr3 & Special Plate Qtr3
            //     } else if (match.matchNo == 30) {//R161
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[47], draw.Matches[43], match, 1);//Qtr3 & Special Plate Qtr3
            //     } else if (match.matchNo == 31) {//R161
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[48], draw.Matches[44], match, 2);//Qtr4 & Special Plate Qtr4
            //     } else if (match.matchNo == 32) {//R161
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[48], draw.Matches[44], match, 2);//Qtr4 & Special Plate Qtr4

            //     } else if (match.matchNo == 33) {//Cons Qtrs
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[51], draw.Matches[49], match, 1);//Cons Semi1 & 29-32th Place 1
            //     } else if (match.matchNo == 34) {//Cons Qtrs
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[51], draw.Matches[49], match, 2);//Cons Semi1 & 29-32th Place 1
            //     } else if (match.matchNo == 35) {//Cons Qtrs
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[52], draw.Matches[50], match, 1);//Cons Semi2 & 29-32th Place 2
            //     } else if (match.matchNo == 36) {//Cons Qtrs
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[52], draw.Matches[50], match, 2);//Cons Semi2 & 29-32th Place 2
            //     } else if (match.matchNo == 37) {//Plate Qtrs
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[55], draw.Matches[53], match, 1);//Plate Semi1 & 24-24 Semi 1
            //     } else if (match.matchNo == 38) {//Plate Qtrs
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[55], draw.Matches[53], match, 2);//Plate Semi1 & 24-24 Semi 1
            //     } else if (match.matchNo == 39) {//Plate Qtrs
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[56], draw.Matches[54], match, 1);//Plate Semi2 & 24-24 Semi 2
            //     } else if (match.matchNo == 40) {//Plate Qtrs
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[56], draw.Matches[54], match, 2);//Plate Semi2 & 24-24 Semi 2
            //     } else if (match.matchNo == 41) {//Special Plate Qtrs
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[59], draw.Matches[57], match, 1);//Special Plate Semi1 & 13-16 Semi 1
            //     } else if (match.matchNo == 42) {//Special Plate Qtrs
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[59], draw.Matches[57], match, 2);//Special Plate Semi1 & 13-16 Semi 1
            //     } else if (match.matchNo == 43) {//Special Plate Qtrs
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[60], draw.Matches[58], match, 1);//Special Plate Semi2 & 13-16 Semi 2
            //     } else if (match.matchNo == 44) {//Special Plate Qtrs
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[60], draw.Matches[58], match, 2);//Special Plate Semi2 & 13-16 Semi 2
            //     } else if (match.matchNo == 45) {// Qtrs
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[63], draw.Matches[61], match, 1);// Semi1 & 5-8 Semi 1
            //     } else if (match.matchNo == 46) {//Special Plate Qtrs
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[63], draw.Matches[61], match, 2);// Semi1 & 5-8 Semi 1
            //     } else if (match.matchNo == 47) {//Special Plate Qtrs
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[64], draw.Matches[62], match, 1);// Semi2 & 5-8 Semi 2
            //     } else if (match.matchNo == 48) {//Special Plate Qtrs
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[64], draw.Matches[62], match, 2);// Semi2 & 5-8 Semi 2

            //     } else if (match.matchNo == 49) {// 29-32 POs
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[66], draw.Matches[65], match, 1);// 29-30 Final & 31-32 Final
            //     } else if (match.matchNo == 50) {// 29-32 POs
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[66], draw.Matches[65], match, 2);// 29-30 Final & 31-32 Final
            //     } else if (match.matchNo == 51) {//Conso Semis
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[68], draw.Matches[67], match, 1);// Conso Final & 27-28 Final
            //     } else if (match.matchNo == 52) {//Conso Semis
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[68], draw.Matches[67], match, 2);// Conso Final & 27-28 Final
            //     } else if (match.matchNo == 53) {//21-24 Semis
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[70], draw.Matches[69], match, 1);// 21-22 & 23-24
            //     } else if (match.matchNo == 54) {//21-24 Semis
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[70], draw.Matches[69], match, 2);// 21-22 & 23-24
            //     } else if (match.matchNo == 55) {//Plate Semis
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[72], draw.Matches[71], match, 1);// Plate Final & 19-20
            //     } else if (match.matchNo == 56) {//Plate Semis
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[72], draw.Matches[71], match, 2);// Plate Final & 19-20
            //     } else if (match.matchNo == 57) {//13-16 POs
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[74], draw.Matches[73], match, 1);// 13-14 & 15-16
            //     } else if (match.matchNo == 58) {//13-16 POs
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[74], draw.Matches[73], match, 2);// 13-14 & 15-16
            //     } else if (match.matchNo == 59) {//Special Plate Semis
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[76], draw.Matches[75], match, 1);// Special Plate Final & 9-10th Place
            //     } else if (match.matchNo == 60) {//Special Plate Semis
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[76], draw.Matches[75], match, 2);// Special Plate Final & 9-10th Place
            //     } else if (match.matchNo == 61) {//5-8 Semis
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[78], draw.Matches[77], match, 1);// 5-6 & 7-8th Place
            //     } else if (match.matchNo == 62) {//5-8 Semis
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[78], draw.Matches[77], match, 2);// 5-6 & 7-8th Place
            //     } else if (match.matchNo == 63) {// Semis
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[80], draw.Matches[79], match, 1);// Final & Bronze Final
            //     } else if (match.matchNo == 64) {// Semis
            //         this.AssignIDAndNumberToNewMatch(draw.Matches[80], draw.Matches[79], match, 2);// Final & Bronze Final
            //     }
            }
        }
    }

    AssignIDAndNumberToNewMatch(WinnerMatch: Match, LoserMatch: Match, CurrentMatch: Match, PlayerNumber: number, PlatePlayerNumber = 0) {
        if (WinnerMatch && LoserMatch) {
            if (PlayerNumber == 1) {
                WinnerMatch.player1 = CurrentMatch.Winner?.id; 
                WinnerMatch.player1Name = CurrentMatch.Winner?.name; 
                if (CurrentMatch.player3 > 0) {
                    WinnerMatch.player3 = CurrentMatch.Winner?.id; 
                    WinnerMatch.player1Name = CurrentMatch.Winner?.name + '/' + CurrentMatch.Winner?.Partner?.name;
                }
                if (LoserMatch && PlatePlayerNumber == 0) {
                    LoserMatch.player1 = CurrentMatch.Loser?.id; 
                    LoserMatch.player1Name = CurrentMatch.Loser?.name; 
                    if (CurrentMatch.player3 > 0) {
                        LoserMatch.player3 = CurrentMatch.Loser?.id; 
                        LoserMatch.player1Name = CurrentMatch.Loser?.name + '/' + CurrentMatch.Loser?.Partner?.name;
                    }
                } else if (LoserMatch) {
                    LoserMatch.player2 = CurrentMatch.Loser?.id; 
                    LoserMatch.player2Name = CurrentMatch.Loser?.name; 
                    if (CurrentMatch.player4 > 0) {
                        LoserMatch.player4 = CurrentMatch.Loser?.id; 
                        LoserMatch.player2Name = CurrentMatch.Loser?.name + '/' + CurrentMatch.Loser?.Partner?.name;
                    }
                }
            } else {
                WinnerMatch.player2 = CurrentMatch.Winner?.id; 
                WinnerMatch.player2Name = CurrentMatch.Winner?.name; 
                if (CurrentMatch.player4 > 0) {
                    WinnerMatch.player4 = CurrentMatch.Winner?.id; 
                    WinnerMatch.player2Name = CurrentMatch.Winner?.name + '/' + CurrentMatch.Winner?.Partner?.name;
                }
                if (LoserMatch && PlatePlayerNumber == 0) {
                    LoserMatch.player2 = CurrentMatch.Loser?.id; 
                    LoserMatch.player2Name = CurrentMatch.Loser?.name; 
                    if (CurrentMatch.player4 > 0) {
                        LoserMatch.player4 = CurrentMatch.Loser?.id; 
                        LoserMatch.player2Name = CurrentMatch.Loser?.name + '/' + CurrentMatch.Loser?.Partner?.name;
                    }
                } else if (LoserMatch) {
                    LoserMatch.player1 = CurrentMatch.Loser?.id; 
                    LoserMatch.player1Name = CurrentMatch.Loser?.name; 
                    if (CurrentMatch.player3 > 0) {
                        LoserMatch.player3 = CurrentMatch.Loser?.id; 
                        LoserMatch.player1Name = CurrentMatch.Loser?.name + '/' + CurrentMatch.Loser?.Partner?.name;
                    }
                }
            }

            this.APIService.updateMatch(WinnerMatch);
            if(LoserMatch) {
                this.APIService.updateMatch(LoserMatch);
            }
        } else {
            console.log("No Winner or Loser Match Found - neither match saved!");
        }
    }

    isRoundRobinFinished(Places: any[]) {
        var TotalPlayed = 0;
        for (var p = 0; p < Places.length; p++) {
            TotalPlayed = TotalPlayed + Places[p].Wins + Places[p].Losses;
        }
        var TotalMatches = 0;
        switch (Places.length) {
            case 3:
                TotalMatches = 3
                break;
            case 4:
                TotalMatches = 6
                break;
            case 5:
                TotalMatches = 10
                break;
            case 6:
                TotalMatches = 15
                break;
        }
        if (TotalPlayed == TotalMatches) {
            return true;
        } else {
            return false;
        }
    }

    recreatePlacings() {
        this.DataService.SelectedDraw!.Places1 = [];
        this.DataService.SelectedDraw!.Places2 = [];
        var Players;
    
        for (var sd = 1; sd <= this.DataService.SelectedDraw!.numberOfRRs!; sd++) {
            if (sd < 3) {
                if (sd == 1) {
                    Players = this.DataService.SelectedDraw!.Players1;
                } else {
                    Players = this.DataService.SelectedDraw!.Players2;
                }
    
                if (Players != null && Players.length > 0) {
                    for (var p = 0; p < Players.length; p++) {
                        var Player = Players[p];
                        var Partner = this.getPartnerFromPlayer(Player.id, this.DataService.SelectedDraw!.theEvent?.id);
                        var placing = {
                            name: Player.name,
                            PlayerId: Player.id,
                            Partner: Partner?.id,
                            for: 0,
                            against: 0,
                            diff: 0,
                            wins: 0
                        }
                        if (this.DataService.SelectedDraw!.theEvent?.type === 'Doubles' && Partner) {
                            placing.name = Player.name + "/" + Partner.name;
                        }
                        for (var m = 0; m < this.DataService.SelectedDraw!.Matches!.length; m++) {
                            var match = this.DataService.SelectedDraw!.Matches![m];
                            if (match && match.subDrawNumber != 3) {
                                var winner = this.findWinner(match);
                                var player1 = Number(match.ttScore1) + Number(match.badScore1) + Number(match.squashScore1) + Number(match.tScore1);
                                var player2 = Number(match.ttScore2) + Number(match.badScore2) + Number(match.squashScore2) + Number(match.tScore2);
                                if (winner) {
                                    if (winner.id === Player.id) {
                                        placing.wins = placing.wins + 1;
                                    }
                                }
                                if (player1 > player2 && match.player1 === Player.id) {
                                    placing.for = placing.for + player1;
                                    placing.against = placing.against + player2;
                                } else if (player1 > player2 && match.player2 === Player.id) {
                                    placing.for = placing.for + player2;
                                    placing.against = placing.against + player1;
                                } else if (player2 > player1 && match.player2 === Player.id) {
                                    placing.for = placing.for + player2;
                                    placing.against = placing.against + player1;
                                } else if (player2 > player1 && match.player1 === Player.id) {
                                    placing.for = placing.for + player1;
                                    placing.against = placing.against + player2;
                                }
                            }
                        }
                        placing.diff = placing.for - placing.against
                        if (sd == 1) {
                            this.DataService.SelectedDraw!.Places1.push(placing);
                        } else {
                            this.DataService.SelectedDraw!.Places2.push(placing);
                        }
    
                    }
                    this.DataService.SelectedDraw!.Places1.sort(function (a, b) { if (b.wins === a.wins) { return b.diff - a.diff } return b.wins - a.wins })
                    this.DataService.SelectedDraw!.Places2.sort(function (a, b) { if (b.wins === a.wins) { return b.diff - a.diff } return b.wins - a.wins })
                    this.DataService.SelectedDraw!.Winner = this.DataService.SelectedDraw!.Places1[0].name
                    this.DataService.SelectedDraw!.RunnerUp = this.DataService.SelectedDraw!.Places1[1].name
                }
            }
        }
      }

    CalcNormalLimit(draw: Draw) {
        if (!draw.Players2) {
            draw.Players2 = [];
        }
        if (draw.Players1) {
            return ((draw.Players1!.length * (draw.Players1!.length - 1)) / 2) + ((draw.Players2!.length * (draw.Players2!.length - 1)) / 2);
        } else {
            return 0
        }
    }

    FillRRPlayOffs() {
        for (var m = 0; m < this.DataService.SelectedDraw!.Places1!.length; m++) {
            if (this.DataService.SelectedDraw!.Matches!.length > this.DataService.NormalLimit! + m) {
                if (this.DataService.SelectedDraw!.type == "Singles") {
                    this.DataService.SelectedDraw!.Matches![this.DataService.NormalLimit! + m].player1 = this.DataService.SelectedDraw!.Places1![m].PlayerId;
                    this.DataService.SelectedDraw!.Matches![this.DataService.NormalLimit! + m].player1Name = this.DataService.SelectedDraw!.Places1![m].name;
                } else {
                    this.DataService.SelectedDraw!.Matches![this.DataService.NormalLimit! + m].player1 = this.DataService.SelectedDraw!.Places1![m].PlayerId;
                    this.DataService.SelectedDraw!.Matches![this.DataService.NormalLimit! + m].player1Name = this.DataService.SelectedDraw!.Places1![m].name;
                    this.DataService.SelectedDraw!.Matches![this.DataService.NormalLimit! + m].player3 = this.DataService.SelectedDraw!.Places1![m].Partner.name;
                }
                this.APIService.updateMatch(this.DataService.SelectedDraw!.Matches![this.DataService.NormalLimit! + m]);
            }
        }
        for (var m = 0; m < this.DataService.SelectedDraw!.Places2!.length; m++) {
            if (this.DataService.SelectedDraw!.Matches!.length > this.DataService.NormalLimit! + m) {
                if (this.DataService.SelectedDraw!.type == "Singles") {
                    this.DataService.SelectedDraw!.Matches![this.DataService.NormalLimit! + m].player2 = this.DataService.SelectedDraw!.Places2![m].PlayerId;
                    this.DataService.SelectedDraw!.Matches![this.DataService.NormalLimit! + m].player2Name = this.DataService.SelectedDraw!.Places2![m].name;
                } else {
                    this.DataService.SelectedDraw!.Matches![this.DataService.NormalLimit! + m].player2 = this.DataService.SelectedDraw!.Places2![m].PlayerId;
                    this.DataService.SelectedDraw!.Matches![this.DataService.NormalLimit! + m].player2Name = this.DataService.SelectedDraw!.Places2![m].name;
                    this.DataService.SelectedDraw!.Matches![this.DataService.NormalLimit! + m].player4 = this.DataService.SelectedDraw!.Places2![m].Partner.name;
                }
                this.APIService.updateMatch(this.DataService.SelectedDraw!.Matches![this.DataService.NormalLimit! + m]);
            }
        }
    }

    HaveScoresBeenEntered() {
        var ScoresHaveBeenEntered = false;
        for (var m = 0; m < this.DataService.SelectedDraw!.Matches!.length; m++) {//if a score has been entered then don't allow Manual input mode
            var mh = this.DataService.SelectedDraw!.Matches![m];
            if (mh.ttScore1! + mh.badScore1! + mh.squashScore1! + mh.tScore1! + mh.ttScore2! + mh.badScore2! + mh.squashScore2! + mh.tScore2! > 0) {
                ScoresHaveBeenEntered = true;
            }
        }
        return ScoresHaveBeenEntered
    }

    calculateScores(match: Match) {
        if (match) {
            if (Number(match.ttScore1) + Number(match.badScore1) + Number(match.squashScore1) + Number(match.tScore1) + (Number(match.ttScore2) + Number(match.badScore2) + Number(match.squashScore2) + Number(match.tScore2)) > 0) {
                match.Score = (Number(match.ttScore1) + Number(match.badScore1) + Number(match.squashScore1) + Number(match.tScore1)) + ' - ' + (Number(match.ttScore2) + Number(match.badScore2) + Number(match.squashScore2) + Number(match.tScore2));
                match.score1 = (Number(match.ttScore1) + Number(match.badScore1) + Number(match.squashScore1) + Number(match.tScore1)).toString();
                match.score2 = (Number(match.ttScore2) + Number(match.badScore2) + Number(match.squashScore2) + Number(match.tScore2)).toString();
            }
        }
    }

    // updateKO4PlayerCheckBox() {
    //     if (this.DataService.SelectedDraw.format == 'KO') {
    //         if (this.HaveScoresBeenEntered() == true && this.DataService.SelectedDraw.Matches[2].player1 == 0) {
    //             this.DataService.SelectedDraw.KO4Player = true;
    //             this.DataService.showKO4PlayerOption = false;//don't show option as cannot be changed
    //         } else if (this.HaveScoresBeenEntered() == true) {
    //             this.DataService.SelectedDraw.KO4Player = false;
    //             this.DataService.showKO4PlayerOption = false;//don't show option as cannot be changed
    //         }
    //     }
    // }

    UpdateWinnerOfMatch(match: Match) {
        var Winner = this.findWinner(match);
        if (Winner) {
            match.Winner = Winner;
            match.Loser = this.DataService.Loser!;
            // if (match.player3 > 0) {
            //   match.player1Name = Winner.name + "/" + Winner.Partner.name;
            //   match.Loser.player1name = this.DataService.Loser
            // }
        }
        //store score in match object anyway
        this.calculateScores(match);
      }
    
    UpdateMatchWinners(draw: Draw) {
        draw.Matches!.forEach(match => {
            if (match) {
                this.UpdateWinnerOfMatch(match);
            }
        });
    }

    async addNewDraw() {
        var newDraw: Draw = {
          id: 0,
          name: 'new',
          tornament: this.DataService.SelectedTorn!.id,
          gender: 'U',
          format: '',
          type: '',
          numberOfRRs: 1,
          theEventID: 0,
          Matches: [],
          KO4Player: false,
          Players1: [],
          Players2: [],
          theEvent: new AnEvent(),
          AvailablePlayers: [],
          Places1: [],
          Places2: [],
          Winner: '',
          RunnerUp: '',
        }
        newDraw.id = await this.APIService.createNewDraw(newDraw);
        //this.DataService.selectedDrawIndex = this.DataService.SelectedTorn.draws.length - 1;
        //this.DataService.ChangeDraw(newDraw);
       return newDraw;
    }

    createEntryForPlayer(ThePlayer: any) {
        var newEntry = {
            dateOfEntry: new Date(),
            name: ThePlayer.name,
            singles: false,
            doublesMixed: false,
            Partner: "",
            gender: ThePlayer.gender,
            country: ThePlayer.country,
            province: ThePlayer.province,
            email: ThePlayer.email,
            phone: ThePlayer.phone,
            tornament: this.DataService.SelectedTorn.id,
            playerId: ThePlayer.id,
            PartnerId: 0,
            partnerReq: false,
            ttGrade: ThePlayer.tableTennis / 10,
            badGrade: ThePlayer.badminton / 10,
            sqGrade: ThePlayer.squash / 10,
            tennisGrade: ThePlayer.tennis / 10,
            feesPaid: false,
            comments: '',
            GradePrefer: 0,
            Fee: 0,
            DOB: ThePlayer.dOB,
            id: 0,
            singlesPoints: 0,
            doublesPoints: 0,
            fee: 0,
            SendAnnouncement: false,
            team: 0,
            eventsList: [] as AnEvent[],
            events: '',
            YearsOld: 0
        }
        //newEntry.events = this.DataService.SelectedTorn.events.slice();
        newEntry.eventsList = [];//JSON.parse(JSON.stringify(this.DataService.SelectedTorn.events));
        if (newEntry.gender == "M") {
            newEntry.singlesPoints = (ThePlayer.TableTennis + ThePlayer.Badminton + ThePlayer.Squash + ThePlayer.Tennis) * 20;
            newEntry.doublesPoints = (ThePlayer.TableTennis + ThePlayer.Badminton + ThePlayer.Squash + ThePlayer.Tennis) * 20;
        } else {
            newEntry.singlesPoints = (ThePlayer.TableTennis + ThePlayer.Badminton + ThePlayer.Squash + ThePlayer.Tennis) * 18;
            newEntry.doublesPoints = (ThePlayer.TableTennis + ThePlayer.Badminton + ThePlayer.Squash + ThePlayer.Tennis) * 18;
        }
        //this.DataService.SelectedTorn.entries.splice(0, 0, newEntry);
        //this.addNewEntry(newEntry, false, this.DataService.SelectedTorn.discount);
        this.DataService.SaveState();
        return newEntry
    }

    PopulateAvailablePlayersForSelectedDraw() {//Create List of AvailablePlayers from Entries
        this.DataService.SelectedDraw.AvailablePlayers = [];
        var Day2Time = this.addDays(2,this.DataService.SelectedTorn.endDateOfEvent);
        //if (this.DataService.SelectedTorn && Day2Time > new Date()) {//we don't need to know available players if torn done
            if (this.DataService.SelectedTorn.entries) {
                for (var e = 0; e < this.DataService.SelectedTorn.entries.length; e++) {
                    var Entry = this.DataService.SelectedTorn.entries[e];
                    var PlayerID = Entry.playerId;
                    var PlayerRecord = this.DataService.Players.find((p) => p.id == PlayerID)!;// getPlayerObject(PlayerID, this.DataService.Players);
                    Entry.eventsList.forEach(_event => {
                        if ((this.DataService.SelectedDraw.theEventID === _event.id && (this.DataService.SelectedDraw.gender == 'U' || this.DataService.SelectedDraw.gender == Entry.gender))) {//if they have entered this draws event
                        var BoolAlreadyExists = false;
                        for (var a = 0; a < this.DataService.SelectedDraw.AvailablePlayers.length; a++) {//make sure they are not already in this list
                            if (this.DataService.SelectedDraw.AvailablePlayers[a].id == PlayerID || (this.DataService.SelectedDraw.theEvent.type === "Doubles" && this.getPartnerFromEntry(Entry, this.DataService.SelectedDraw.theEventID)?.id == this.DataService.SelectedDraw.AvailablePlayers[a].id)) {
                            BoolAlreadyExists = true;
                            }
                        }
                        if (this.DataService.SelectedDraw.theEvent.type === "Doubles" && _event.PartnerId == null) {
                            BoolAlreadyExists = true;//don't put them as available if they have not yet been asigned a partner
                        }
                        if (BoolAlreadyExists === false) {
                            this.DataService.SelectedDraw.AvailablePlayers.push(PlayerRecord);
                        }
                        }
                    })
                }
            }
        //}
        if (this.DataService.SelectedDraw.theEvent) {
            this.DataService.SelectedDraw.type = this.DataService.SelectedDraw.theEvent.type
        }
        if (this.DataService.SelectedDraw.type === "Singles") {//seed in order of points
        this.DataService.SelectedDraw.AvailablePlayers.sort(function (a, b) { return b.singlesPoints - a.singlesPoints })
        } else {
            this.DataService.SelectedDraw.AvailablePlayers.sort(function (a, b) { return b.DoublesTotalPoints - a.DoublesTotalPoints })
        }
    }

    FindMatch(matchNumber: number, subDraw: number) {
        return this.DataService.SelectedDraw!.Matches!.find(
                (m: any) =>
                m &&
                typeof m === 'object' &&
                'matchNo' in m &&
                m.matchNo === matchNumber &&
                m.subDrawNumber === subDraw
            ) ?? null;
    }

    async deleteMatches() {
        for (var m = this.DataService.SelectedDraw!.Matches!.length - 1; m >= 0; m--) {
            var match = this.DataService.SelectedDraw!.Matches![m];
            if (match) {
              await this.APIService.deleteMatch(match);
            }
        }
        this.DataService.SelectedDraw!.Matches = [];
    }

    convertEventsStringsIntoArray(torn: Tornament) {// this converts the torn.entries.events from a string array to an object array
        torn.entries?.forEach(entry => {
          var EntryString = entry.events?.toString();//because it gets save tot eh DB as a string array of comma seperated event IDs
          var EntryEvents = EntryString?.split(",");
          entry.eventsList = [];
          EntryEvents?.forEach(eventId => {
            //if eventId is 3120(8) then need to split on ( to get partner id also
            eventId = eventId.trim();
            var eventIdParts = eventId.split("(");
            eventId = eventIdParts[0];
            var PartnerId = 0;
            if (eventIdParts.length > 1) {
              PartnerId = +eventIdParts[1].replace(")", "");
            }
    
            var EventObjectUnconverted = torn.events?.find((ev) => ev.id == +eventId);
            if (EventObjectUnconverted) {
                var EventObject = JSON.parse(JSON.stringify(EventObjectUnconverted));
                if (PartnerId > 0) {
                    EventObject.PartnerId = PartnerId;
                    var PartnerObject = this.DataService.Players?.find((p) => p.id == PartnerId);
                    EventObject.Partner = PartnerObject;
                }
                entry.eventsList?.push(EventObject);
            }
          });
        });
    }

    getPartnerFromPlayer(playerid?: number, eventId?: number) {
        const entry = this.DataService.SelectedTorn!.entries?.find(entry => entry.playerId === playerid);
        return this.getPartnerFromEntry(entry, eventId!)
      }

    //   getPartnerFromPlayerAndDraw(playerid, draw) {
    //     const entry = this.DataService.SelectedTorn.entries.find(entry => entry.playerId === playerid);
    //     return this.getPartnerFromEntry(entry, draw.theEvent.id)
    //   }
    
      getPartnerFromEntry(entry: Entry | undefined, eventId: number) {
        var TheEvent = entry?.eventsList?.find(e => e.id === eventId);
        if (TheEvent && TheEvent.PartnerId) {
          var PartnerObject = this.DataService.Players?.find((p) => p.id == TheEvent?.PartnerId);
          return PartnerObject;
        } else {
          return null;
        }
      }

      getEventForPlayer(playerId: number, eventId: number) {
        const entry = this.DataService.SelectedTorn!.entries?.find(entry => entry.playerId === playerId);
        return entry?.eventsList?.find(e => e.id === eventId);
      }

    isOdd(num: number): boolean {
        return num % 2 === 1;
    }

    reCalcTeamTotals() {
        if (this.DataService.SelectedTorn!.isTeams && this.DataService.SelectedTorn!.Teams!.length > 0) {
            this.DataService.SelectedTorn!.Teams?.forEach((team, index) => {
                team.Points = 0;
            })
            this.DataService.SelectedTorn!.draws?.forEach((draw, index) => {
                draw.Matches?.forEach((match, index2) => {
                    var ThePlayer1 = this.DataService.Players?.find((p) => p.id == match.player1);//getPlayerObject(match.Player1, this.DataService.SelectedTorn.DoublesPlayers)
                    var ThePlayer2 = this.DataService.Players?.find((p) => p.id == match.player2);//getPlayerObject(match.Player2, this.DataService.SelectedTorn.DoublesPlayers)
                    this.DataService.SelectedTorn!.Teams?.forEach((team, index3) => {
                        if (team.id == ThePlayer1?.Team) {
                            team.Points = team.Points! + (match.ttScore1 || 0) + (match.badScore1 || 0) + (match.squashScore1 || 0) + (match.tScore1 || 0);
                        }
                        if (team.id == ThePlayer2?.Team) {
                            team.Points = team.Points! + (match.ttScore2 || 0) + (match.badScore2 || 0) + (match.squashScore2 || 0) + (match.tScore2 || 0);
                        }
                    })
                })
            })
            this.DataService.SelectedTorn!.Teams?.sort((a, b) => b.Points! - a.Points!);
        }
    }
}
